module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The bounty of squashes, pumpkins, sweet potatoes, apples, pears, cranberries, nuts, greens, Brussels spouts, and other veggies typical of this holiday’s theme gives vegans and vegetarians the ability to enjoy a full-scale feast. Still, Thanksgiving can be a trying time for the meatless crowd. That’s because the holiday is so completely bound up with the concept of turkey. So much emphasis is placed on this hapless bird, from construction-paper turkeys fashioned by legions of schoolchildren each year, to the ostentatious annual “presidential pardon” of two turkeys by whomever is occupying the White House.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Vegans and vegetarians would prefer that all turkeys were pardoned from their ignominious fates, and that the holiday be returned to its original intent—from the 1621 proclamation of Governor William Bradford of Massachusetts to “render thanksgiving … for the abundant harvest of Indian corn, wheat, beans, squashes, and garden vegetables.” Indeed, it’s the “Three Sisters” of Native American lore—corn, beans, and squash—that were once the most honored components of the feast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The beauty of Thanksgiving is that it’s so inclusive—you need not be from any particular culture or creed, nor adhere to any denominational belief to partake of its pleasures. It’s a holiday for everyone—a day for giving appreciation for the abundance that exists in our lives, and enjoying the bountiful foods of the season.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Since Thanksgiving is such a favored holiday in the vegan and vegetarian realms, I’m launching this book with the biggest and most plentiful chapter. Plant-based meals for Thanksgiving are sure to have their offbeat twists, but the ingredients emphasized here are those most closely associated with the holiday and its fresh, seasonal offerings. Corn, beans, squashes, sweet potatoes, apples, nuts, and cranberries figure prominently in these dishes. Mixing and matching the components of your Thanksgiving meal from these selections will keep you in good stead for years to come, whether you’re the host or the guest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Though none of the dishes here are terribly complicated, if you want to serve a dish from each of the categories from soups to desserts, you might consider doing this cooperatively with all participants making one or two dishes. That way everyone can enjoy a wonderful feast without feeling wiped out from a lot of preparation.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "h3",
    staticStyle: {
      "margin-top": "5em"
    }
  }, [_vm._v("THANKSGIVING ETIQUETTE")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('big', [_c('big', [_vm._v("What do you do if")])], 1), _vm._v(" you’re a vegan or vegetarian invited to a traditional Thanksgiving gathering (or, for that matter, any holiday gathering at which you know that meat will be served)? If you’re going to be in the veg minority, volunteer to bring a main dish that you can enjoy (and, possibly, a stuffing baked in a casserole) and that others can have as side dishes. Perhaps you’re a non-veg reader consulting this book because you’re hosting the meal and expecting a vegan or vegetarian or two. If that’s the case, and your veg guests haven’t volunteered to contribute anything (or if you’d like to try making something to impress the new vegan in the family), read on for plenty of alternative main dishes and stuffings. After all, that’s exactly what this book is about.")], 1), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81), _vm._v(" "), _vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86), _vm._v(" "), _vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91), _vm._v(" "), _vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95), _vm._v(" "), _vm._m(96), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _vm._m(99), _vm._v(" "), _vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _vm._m(102), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(103), _vm._v(" "), _vm._m(104), _vm._v(" "), _vm._m(105), _vm._v(" "), _vm._m(106), _vm._v(" "), _vm._m(107), _vm._v(" "), _vm._m(108), _vm._v(" "), _vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _vm._m(117), _vm._v(" "), _vm._m(118), _vm._v(" "), _vm._m(119), _vm._v(" "), _vm._m(120), _vm._v(" "), _vm._m(121), _vm._v(" "), _vm._m(122), _vm._v(" "), _vm._m(123), _vm._v(" "), _vm._m(124), _vm._v(" "), _vm._m(125), _vm._v(" "), _vm._m(126), _vm._v(" "), _vm._m(127), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(128), _vm._v(" "), _vm._m(129), _vm._v(" "), _vm._m(130), _vm._v(" "), _vm._m(131), _vm._v(" "), _vm._m(132), _vm._v(" "), _vm._m(133), _vm._v(" "), _vm._m(134), _vm._v(" "), _vm._m(135), _vm._v(" "), _vm._m(136), _vm._v(" "), _vm._m(137), _vm._v(" "), _vm._m(138), _vm._v(" "), _vm._m(139), _vm._v(" "), _vm._m(140), _vm._v(" "), _vm._m(141), _vm._v(" "), _vm._m(142), _vm._v(" "), _vm._m(143), _vm._v(" "), _vm._m(144), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(147), _vm._v(" "), _vm._m(148), _vm._v(" "), _vm._m(149), _vm._v(" "), _vm._m(150), _vm._v(" "), _vm._m(151), _vm._v(" "), _vm._m(152), _vm._v(" "), _vm._m(153), _vm._v(" "), _vm._m(154), _vm._v(" "), _vm._m(155), _vm._v(" "), _vm._m(156), _vm._v(" "), _vm._m(157), _vm._v(" "), _vm._m(158), _vm._v(" "), _vm._m(159), _vm._v(" "), _vm._m(160), _vm._v(" "), _vm._m(161), _vm._v(" "), _vm._m(162), _vm._v(" "), _vm._m(163), _vm._v(" "), _vm._m(164), _vm._v(" "), _vm._m(165), _vm._v(" "), _c('p', {
    staticClass: "tbx2"
  }, [_vm._v("Make a well in the center of the dry ingredients. Pour in the yogurt, oil, and rice milk. Stir until well combined, adding more rice milk if needed, to make a smooth, slightly stiff batter. Stir in the chilies, optional corn kernels, and optional cheese.")]), _vm._v(" "), _vm._m(166), _vm._v(" "), _vm._m(167), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(168), _vm._v(" "), _vm._m(169), _vm._v(" "), _vm._m(170), _vm._v(" "), _vm._m(171), _vm._v(" "), _vm._m(172), _vm._v(" "), _vm._m(173), _vm._v(" "), _vm._m(174), _vm._v(" "), _vm._m(175), _vm._v(" "), _vm._m(176), _vm._v(" "), _vm._m(177), _vm._v(" "), _vm._m(178), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(179), _vm._v(" "), _vm._m(180), _vm._v(" "), _vm._m(181), _vm._v(" "), _vm._m(182), _vm._v(" "), _vm._m(183), _vm._v(" "), _vm._m(184), _vm._v(" "), _vm._m(185), _vm._v(" "), _vm._m(186), _vm._v(" "), _vm._m(187), _vm._v(" "), _vm._m(188), _vm._v(" "), _vm._m(189), _vm._v(" "), _vm._m(190), _vm._v(" "), _vm._m(191), _vm._v(" "), _vm._m(192), _vm._v(" "), _vm._m(193), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(194), _vm._v(" "), _vm._m(195), _vm._v(" "), _vm._m(196), _vm._v(" "), _vm._m(197), _vm._v(" "), _vm._m(198), _vm._v(" "), _vm._m(199), _vm._v(" "), _vm._m(200), _vm._v(" "), _vm._m(201), _vm._v(" "), _vm._m(202), _vm._v(" "), _vm._m(203), _vm._v(" "), _vm._m(204), _vm._v(" "), _vm._m(205), _vm._v(" "), _vm._m(206), _vm._v(" "), _vm._m(207), _vm._v(" "), _vm._m(208), _vm._v(" "), _vm._m(209), _vm._v(" "), _vm._m(210), _vm._v(" "), _vm._m(211), _vm._v(" "), _vm._m(212), _vm._v(" "), _vm._m(213), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(214), _vm._v(" "), _vm._m(215), _vm._v(" "), _vm._m(216), _vm._v(" "), _vm._m(217), _vm._v(" "), _vm._m(218), _vm._v(" "), _vm._m(219), _vm._v(" "), _vm._m(220), _vm._v(" "), _vm._m(221), _vm._v(" "), _vm._m(222), _vm._v(" "), _vm._m(223), _vm._v(" "), _vm._m(224), _vm._v(" "), _vm._m(225), _vm._v(" "), _vm._m(226), _vm._v(" "), _vm._m(227), _vm._v(" "), _vm._m(228), _vm._v(" "), _vm._m(229), _vm._v(" "), _vm._m(230), _vm._v(" "), _vm._m(231), _vm._v(" "), _vm._m(232), _vm._v(" "), _vm._m(233), _vm._v(" "), _vm._m(234), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(235), _vm._v(" "), _vm._m(236), _vm._v(" "), _vm._m(237), _vm._v(" "), _vm._m(238), _vm._v(" "), _vm._m(239), _vm._v(" "), _vm._m(240), _vm._v(" "), _vm._m(241), _vm._v(" "), _vm._m(242), _vm._v(" "), _vm._m(243), _vm._v(" "), _vm._m(244), _vm._v(" "), _vm._m(245), _vm._v(" "), _vm._m(246), _vm._v(" "), _vm._m(247), _vm._v(" "), _vm._m(248), _vm._v(" "), _vm._m(249), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("• Tiny orange sections")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("• Diced apple")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("• Diced pear")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("• Dried cherries or golden raisins in place of cranberries")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("• Toasted walnut or pecans in place of cashews")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(250), _vm._v(" "), _vm._m(251), _vm._v(" "), _vm._m(252), _vm._v(" "), _vm._m(253), _vm._v(" "), _vm._m(254), _vm._v(" "), _vm._m(255), _vm._v(" "), _vm._m(256), _vm._v(" "), _vm._m(257), _vm._v(" "), _vm._m(258), _vm._v(" "), _vm._m(259), _vm._v(" "), _vm._m(260), _vm._v(" "), _vm._m(261), _vm._v(" "), _vm._m(262), _vm._v(" "), _vm._m(263), _vm._v(" "), _vm._m(264), _vm._v(" "), _vm._m(265), _vm._v(" "), _vm._m(266), _vm._v(" "), _vm._m(267), _vm._v(" "), _vm._m(268), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(269), _vm._v(" "), _c('p', {
    staticClass: "h3",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_vm._v("WHAT ABOUT FAUX TURKEY?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('big', [_c('big', [_vm._v("For many years, I’ve been")])], 1), _vm._v(" interviewed as an expert on vegetarian and vegan Thanksgiving meals. Invariably, I’m asked what I think about “tofu turkey” (though they aren’t entirely made of tofu; often, gluten and beans are part of the mix), a product whose popularity has soared in recent years. “Well, I suppose it’s preferable to the real thing,” I reply tactfully. Personally, I’d rather focus on harvest produce for a truer sense of the holiday. Scouring local markets for the best of late-season crops becomes part of the celebration. To my mind, even a fake turkey is a diversion from the universal message of the Thanksgiving celebration.")], 1), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still, I very much understand why those who have given up meat would want to re-create a version of the famed holiday centerpiece. So much of what makes holiday meals appealing is ritual and nostalgia—dipping back into the past for the kind of continuity and familiarity that gives our crazy, hectic lives little islands of comfort and order. So if that’s what makes your holiday table complete, I say, to each his or her own. There are even lots of turkey-style tofu or seitan roast—stuffing and all—recipes and videos on the Web, if you want to make the dish completely from scratch. It’s quite a project, but for many, well worth the effort. This savory stuffed centerpiece, whether you buy it prepared (Tofurky and Field Roast are two popular brands) or make it via an online tutorial, is nearly equally popular for Christmas dinners as well.")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(270), _vm._v(" "), _vm._m(271), _vm._v(" "), _vm._m(272), _vm._v(" "), _vm._m(273), _vm._v(" "), _vm._m(274), _vm._v(" "), _vm._m(275), _vm._v(" "), _vm._m(276), _vm._v(" "), _vm._m(277), _vm._v(" "), _vm._m(278), _vm._v(" "), _vm._m(279), _vm._v(" "), _vm._m(280), _vm._v(" "), _vm._m(281), _vm._v(" "), _vm._m(282), _vm._v(" "), _vm._m(283), _vm._v(" "), _vm._m(284), _vm._v(" "), _vm._m(285), _vm._v(" "), _vm._m(286), _vm._v(" "), _vm._m(287), _vm._v(" "), _vm._m(288), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(289), _vm._v(" "), _vm._m(290), _vm._v(" "), _vm._m(291), _vm._v(" "), _vm._m(292), _vm._v(" "), _vm._m(293), _vm._v(" "), _vm._m(294), _vm._v(" "), _vm._m(295), _vm._v(" "), _vm._m(296), _vm._v(" "), _vm._m(297), _vm._v(" "), _vm._m(298), _vm._v(" "), _vm._m(299), _vm._v(" "), _vm._m(300), _vm._v(" "), _vm._m(301), _vm._v(" "), _vm._m(302), _vm._v(" "), _vm._m(303), _vm._v(" "), _vm._m(304), _vm._v(" "), _vm._m(305), _vm._v(" "), _vm._m(306), _vm._v(" "), _vm._m(307), _vm._v(" "), _vm._m(308), _vm._v(" "), _vm._m(309), _vm._v(" "), _vm._m(310), _vm._v(" "), _vm._m(311), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(312), _vm._v(" "), _vm._m(313), _vm._v(" "), _c('p', {
    staticClass: "tbx1"
  }, [_c('b', [_c('big', [_c('big', [_vm._v("A number of recipes in")])], 1), _vm._v(" this book call for baked winter squash, so rather than repeat the same directions, here are a few handy steps to follow each time:")], 1)]), _vm._v(" "), _vm._m(314), _vm._v(" "), _vm._m(315), _vm._v(" "), _vm._m(316), _vm._v(" "), _vm._m(317), _vm._v(" "), _vm._m(318), _vm._v(" "), _vm._m(319), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(320), _vm._v(" "), _vm._m(321), _vm._v(" "), _vm._m(322), _vm._v(" "), _vm._m(323), _vm._v(" "), _vm._m(324), _vm._v(" "), _vm._m(325), _vm._v(" "), _vm._m(326), _vm._v(" "), _vm._m(327), _vm._v(" "), _vm._m(328), _vm._v(" "), _vm._m(329), _vm._v(" "), _vm._m(330), _vm._v(" "), _vm._m(331), _vm._v(" "), _vm._m(332), _vm._v(" "), _vm._m(333), _vm._v(" "), _vm._m(334), _vm._v(" "), _vm._m(335), _vm._v(" "), _vm._m(336), _vm._v(" "), _vm._m(337), _vm._v(" "), _vm._m(338), _vm._v(" "), _vm._m(339), _vm._v(" "), _vm._m(340), _vm._v(" "), _vm._m(341), _vm._v(" "), _vm._m(342), _vm._v(" "), _c('p', {
    staticClass: "tbx2"
  }, [_vm._v("Combine the quinoa with the broth in a small saucepan. Bring to a gentle boil, then lower the heat, cover, and simmer gently until the water is absorbed, about 15 to 20 minutes.")]), _vm._v(" "), _vm._m(343), _vm._v(" "), _vm._m(344), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(345), _vm._v(" "), _vm._m(346), _vm._v(" "), _vm._m(347), _vm._v(" "), _vm._m(348), _vm._v(" "), _vm._m(349), _vm._v(" "), _vm._m(350), _vm._v(" "), _vm._m(351), _vm._v(" "), _vm._m(352), _vm._v(" "), _vm._m(353), _vm._v(" "), _vm._m(354), _vm._v(" "), _vm._m(355), _vm._v(" "), _vm._m(356), _vm._v(" "), _vm._m(357), _vm._v(" "), _vm._m(358), _vm._v(" "), _vm._m(359), _vm._v(" "), _vm._m(360), _vm._v(" "), _vm._m(361), _vm._v(" "), _vm._m(362), _vm._v(" "), _vm._m(363), _vm._v(" "), _vm._m(364), _vm._v(" "), _vm._m(365), _vm._v(" "), _c('p', {
    staticClass: "tbx2"
  }, [_vm._v("Meanwhile, heat the oil in a small skillet. Add the onion and sauté until it is golden brown. Combine the sautéed onion in a mixing bowl with the breadcrumbs, cooked rice, and pecans.")]), _vm._v(" "), _vm._m(366), _vm._v(" "), _vm._m(367), _vm._v(" "), _vm._m(368), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(369), _vm._v(" "), _vm._m(370), _vm._v(" "), _vm._m(371), _vm._v(" "), _vm._m(372), _vm._v(" "), _vm._m(373), _vm._v(" "), _vm._m(374), _vm._v(" "), _vm._m(375), _vm._v(" "), _vm._m(376), _vm._v(" "), _vm._m(377), _vm._v(" "), _vm._m(378), _vm._v(" "), _vm._m(379), _vm._v(" "), _vm._m(380), _vm._v(" "), _vm._m(381), _vm._v(" "), _vm._m(382), _vm._v(" "), _vm._m(383), _vm._v(" "), _vm._m(384), _vm._v(" "), _vm._m(385), _vm._v(" "), _vm._m(386), _vm._v(" "), _vm._m(387), _vm._v(" "), _vm._m(388), _vm._v(" "), _vm._m(389), _vm._v(" "), _vm._m(390), _vm._v(" "), _vm._m(391), _vm._v(" "), _vm._m(392), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(393), _vm._v(" "), _vm._m(394), _vm._v(" "), _vm._m(395), _vm._v(" "), _vm._m(396), _vm._v(" "), _vm._m(397), _vm._v(" "), _vm._m(398), _vm._v(" "), _vm._m(399), _vm._v(" "), _vm._m(400), _vm._v(" "), _vm._m(401), _vm._v(" "), _vm._m(402), _vm._v(" "), _vm._m(403), _vm._v(" "), _vm._m(404), _vm._v(" "), _vm._m(405), _vm._v(" "), _vm._m(406), _vm._v(" "), _vm._m(407), _vm._v(" "), _vm._m(408), _vm._v(" "), _vm._m(409), _vm._v(" "), _vm._m(410), _vm._v(" "), _vm._m(411), _vm._v(" "), _vm._m(412), _vm._v(" "), _vm._m(413), _vm._v(" "), _vm._m(414), _vm._v(" "), _vm._m(415), _vm._v(" "), _vm._m(416), _vm._v(" "), _vm._m(417), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(418), _vm._v(" "), _vm._m(419), _vm._v(" "), _vm._m(420), _vm._v(" "), _vm._m(421), _vm._v(" "), _vm._m(422), _vm._v(" "), _vm._m(423), _vm._v(" "), _vm._m(424), _vm._v(" "), _vm._m(425), _vm._v(" "), _vm._m(426), _vm._v(" "), _vm._m(427), _vm._v(" "), _vm._m(428), _vm._v(" "), _vm._m(429), _vm._v(" "), _vm._m(430), _vm._v(" "), _vm._m(431), _vm._v(" "), _vm._m(432), _vm._v(" "), _vm._m(433), _vm._v(" "), _vm._m(434), _vm._v(" "), _vm._m(435), _vm._v(" "), _vm._m(436), _vm._v(" "), _vm._m(437), _vm._v(" "), _vm._m(438), _vm._v(" "), _vm._m(439), _vm._v(" "), _vm._m(440), _vm._v(" "), _vm._m(441), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(442), _vm._v(" "), _vm._m(443), _vm._v(" "), _vm._m(444), _vm._v(" "), _vm._m(445), _vm._v(" "), _vm._m(446), _vm._v(" "), _vm._m(447), _vm._v(" "), _vm._m(448), _vm._v(" "), _vm._m(449), _vm._v(" "), _vm._m(450), _vm._v(" "), _vm._m(451), _vm._v(" "), _vm._m(452), _vm._v(" "), _vm._m(453), _vm._v(" "), _vm._m(454), _vm._v(" "), _vm._m(455), _vm._v(" "), _vm._m(456), _vm._v(" "), _vm._m(457), _vm._v(" "), _vm._m(458), _vm._v(" "), _vm._m(459), _vm._v(" "), _vm._m(460), _vm._v(" "), _vm._m(461), _vm._v(" "), _vm._m(462), _vm._v(" "), _vm._m(463), _vm._v(" "), _vm._m(464), _vm._v(" "), _vm._m(465), _vm._v(" "), _vm._m(466), _vm._v(" "), _vm._m(467), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(468), _vm._v(" "), _vm._m(469), _vm._v(" "), _vm._m(470), _vm._v(" "), _vm._m(471), _vm._v(" "), _vm._m(472), _vm._v(" "), _vm._m(473), _vm._v(" "), _vm._m(474), _vm._v(" "), _vm._m(475), _vm._v(" "), _vm._m(476), _vm._v(" "), _vm._m(477), _vm._v(" "), _vm._m(478), _vm._v(" "), _vm._m(479), _vm._v(" "), _vm._m(480), _vm._v(" "), _vm._m(481), _vm._v(" "), _vm._m(482), _vm._v(" "), _vm._m(483), _vm._v(" "), _vm._m(484), _vm._v(" "), _vm._m(485), _vm._v(" "), _vm._m(486), _vm._v(" "), _vm._m(487), _vm._v(" "), _vm._m(488), _vm._v(" "), _vm._m(489), _vm._v(" "), _vm._m(490), _vm._v(" "), _vm._m(491), _vm._v(" "), _vm._m(492), _vm._v(" "), _vm._m(493), _vm._v(" "), _vm._m(494), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(495), _vm._v(" "), _c('p', {
    staticClass: "h3",
    staticStyle: {
      "margin-top": "4em"
    },
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("HOMEMADE BREADCRUMBS")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('big', [_c('big', [_vm._v("Sure, you can buy prepared")])], 1), _vm._v(" breadcrumbs, but if you have a food processor, using prepared breadcrumbs is one shortcut that isn’t worth taking (and I am quite fond of shortcuts). Store-bought breadcrumbs are often dry and almost always overpriced, especially the ones called “panko.” I mean seriously, they’re just breadcrumbs! It takes less than a minute to make them at home, and it’s also a great way to use up ends of bread.")], 1), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There’s nothing more to making breadcrumbs than tearing up a few slices of bread, putting them in the food processor, and letting it run until the bread is reduced to coarse crumbs. An average-size slice will yield ½ to ¾ cup of crumbs.")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(496), _vm._v(" "), _vm._m(497), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('big', [_c('big', [_vm._v("Unlike prepared breadcrumbs")])], 1), _vm._v(", commercial seasoning blends are a staple in my kitchen. I think they’re nifty and useful. Seasoning blends provide a flavor punch by combining anywhere from a dozen to two dozen herbs and spices in one bottle, which, to my mind, means economy of both time and money. Seasoning blends are an especially good way to season stuffings, and I make ample use of them in most of the recipes in this chapter. Spike Gourmet Natural Seasoning (be aware that this one isn’t soy-free) and Simply Organic All-Purpose Seasoning are my favorites from the natural foods store; Mrs. Dash Table Blend is one I like from the supermarket.")], 1), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Curry powder and chili powder are seasoning blends as well; no matter which kind you use, make sure they’re fresh and good quality.")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(498), _vm._v(" "), _vm._m(499), _vm._v(" "), _vm._m(500), _vm._v(" "), _vm._m(501), _vm._v(" "), _vm._m(502), _vm._v(" "), _vm._m(503), _vm._v(" "), _vm._m(504), _vm._v(" "), _vm._m(505), _vm._v(" "), _vm._m(506), _vm._v(" "), _vm._m(507), _vm._v(" "), _vm._m(508), _vm._v(" "), _vm._m(509), _vm._v(" "), _vm._m(510), _vm._v(" "), _vm._m(511), _vm._v(" "), _vm._m(512), _vm._v(" "), _vm._m(513), _vm._v(" "), _vm._m(514), _vm._v(" "), _vm._m(515), _vm._v(" "), _vm._m(516), _vm._v(" "), _vm._m(517), _vm._v(" "), _vm._m(518), _vm._v(" "), _vm._m(519), _vm._v(" "), _vm._m(520), _vm._v(" "), _vm._m(521), _vm._v(" "), _vm._m(522), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(523), _vm._v(" "), _vm._m(524), _vm._v(" "), _vm._m(525), _vm._v(" "), _vm._m(526), _vm._v(" "), _vm._m(527), _vm._v(" "), _vm._m(528), _vm._v(" "), _vm._m(529), _vm._v(" "), _vm._m(530), _vm._v(" "), _vm._m(531), _vm._v(" "), _vm._m(532), _vm._v(" "), _vm._m(533), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(534), _vm._v(" "), _vm._m(535), _vm._v(" "), _vm._m(536), _vm._v(" "), _vm._m(537), _vm._v(" "), _vm._m(538), _vm._v(" "), _vm._m(539), _vm._v(" "), _vm._m(540), _vm._v(" "), _vm._m(541), _vm._v(" "), _vm._m(542), _vm._v(" "), _vm._m(543), _vm._v(" "), _vm._m(544), _vm._v(" "), _vm._m(545), _vm._v(" "), _vm._m(546), _vm._v(" "), _vm._m(547), _vm._v(" "), _vm._m(548), _vm._v(" "), _vm._m(549), _vm._v(" "), _vm._m(550), _vm._v(" "), _vm._m(551), _vm._v(" "), _vm._m(552), _vm._v(" "), _vm._m(553), _vm._v(" "), _vm._m(554), _vm._v(" "), _vm._m(555), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(556), _vm._v(" "), _vm._m(557), _vm._v(" "), _vm._m(558), _vm._v(" "), _vm._m(559), _vm._v(" "), _vm._m(560), _vm._v(" "), _vm._m(561), _vm._v(" "), _vm._m(562), _vm._v(" "), _vm._m(563), _vm._v(" "), _vm._m(564), _vm._v(" "), _vm._m(565), _vm._v(" "), _vm._m(566), _vm._v(" "), _vm._m(567), _vm._v(" "), _vm._m(568), _vm._v(" "), _vm._m(569), _vm._v(" "), _vm._m(570), _vm._v(" "), _vm._m(571), _vm._v(" "), _vm._m(572), _vm._v(" "), _vm._m(573), _vm._v(" "), _vm._m(574), _vm._v(" "), _vm._m(575), _vm._v(" "), _vm._m(576), _vm._v(" "), _vm._m(577), _vm._v(" "), _vm._m(578), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(579), _vm._v(" "), _vm._m(580), _vm._v(" "), _vm._m(581), _vm._v(" "), _vm._m(582), _vm._v(" "), _vm._m(583), _vm._v(" "), _vm._m(584), _vm._v(" "), _vm._m(585), _vm._v(" "), _vm._m(586), _vm._v(" "), _vm._m(587), _vm._v(" "), _vm._m(588), _vm._v(" "), _vm._m(589), _vm._v(" "), _vm._m(590), _vm._v(" "), _vm._m(591), _vm._v(" "), _vm._m(592), _vm._v(" "), _vm._m(593), _vm._v(" "), _vm._m(594), _vm._v(" "), _vm._m(595), _vm._v(" "), _vm._m(596), _vm._v(" "), _vm._m(597), _vm._v(" "), _vm._m(598), _vm._v(" "), _vm._m(599), _vm._v(" "), _vm._m(600), _vm._v(" "), _vm._m(601), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(602), _vm._v(" "), _c('p', {
    staticClass: "h3",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_vm._v("SAVORY VEGAN STUFFINGS")]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('big', [_c('big', [_vm._v("Some years back—actually many years")])], 1), _vm._v(" ago—there was a TV commercial in which a reporter accosted people in the street and asked whether they would prefer rice, potatoes, or stuffing for dinner, if given a choice. No one seemed to think this was a strange question; after all, these were actors. So, of course, the respondents invariably and emphatically chose stuffing. One young man exclaimed eagerly, “I’m going to call my mom right now and ask her to make some!”")], 1), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("To the all-American team of Mom and apple pie, we can also add stuffing. Though the latter doesn’t usually cause as much culinary ecstasy as this commercial suggests, it does evoke comfort-food nostalgia. Stuffing is a good, sturdy sort of everyday dish. Although it’s not often considered other than for holiday meals, it’s a nice change of pace from other starch-based side dishes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Many of us who no longer use stuffing for its original purpose still warmly welcome it as a side dish or as a filling for seasonal vegetables. Most of the stuffing recipes given here follow tradition by including bread cubes or breadcrumbs as a basic ingredient. For those of you who eat gluten-free, the good news is that there are several brands of gluten-free bread that can be used to make the bread cubes or breadcrumbs in these recipes. I’ve also included a polenta-based stuffing recipe—you don’t have to be on a gluten-free regimen to love it.")]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(603), _vm._v(" "), _vm._m(604), _vm._v(" "), _vm._m(605), _vm._v(" "), _vm._m(606), _vm._v(" "), _vm._m(607), _vm._v(" "), _vm._m(608), _vm._v(" "), _vm._m(609), _vm._v(" "), _vm._m(610), _vm._v(" "), _vm._m(611), _vm._v(" "), _vm._m(612), _vm._v(" "), _vm._m(613), _vm._v(" "), _vm._m(614), _vm._v(" "), _vm._m(615), _vm._v(" "), _vm._m(616), _vm._v(" "), _vm._m(617), _vm._v(" "), _vm._m(618), _vm._v(" "), _vm._m(619), _vm._v(" "), _vm._m(620), _vm._v(" "), _vm._m(621), _vm._v(" "), _vm._m(622), _vm._v(" "), _vm._m(623), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(624), _vm._v(" "), _vm._m(625), _vm._v(" "), _vm._m(626), _vm._v(" "), _vm._m(627), _vm._v(" "), _vm._m(628), _vm._v(" "), _vm._m(629), _vm._v(" "), _vm._m(630), _vm._v(" "), _vm._m(631), _vm._v(" "), _vm._m(632), _vm._v(" "), _vm._m(633), _vm._v(" "), _vm._m(634), _vm._v(" "), _vm._m(635), _vm._v(" "), _vm._m(636), _vm._v(" "), _vm._m(637), _vm._v(" "), _vm._m(638), _vm._v(" "), _vm._m(639), _vm._v(" "), _vm._m(640), _vm._v(" "), _vm._m(641), _vm._v(" "), _vm._m(642), _vm._v(" "), _vm._m(643), _vm._v(" "), _vm._m(644), _vm._v(" "), _vm._m(645), _vm._v(" "), _vm._m(646), _vm._v(" "), _vm._m(647), _vm._v(" "), _vm._m(648), _vm._v(" "), _vm._m(649), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(650), _vm._v(" "), _vm._m(651), _vm._v(" "), _vm._m(652), _vm._v(" "), _vm._m(653), _vm._v(" "), _vm._m(654), _vm._v(" "), _vm._m(655), _vm._v(" "), _vm._m(656), _vm._v(" "), _vm._m(657), _vm._v(" "), _vm._m(658), _vm._v(" "), _vm._m(659), _vm._v(" "), _vm._m(660), _vm._v(" "), _vm._m(661), _vm._v(" "), _vm._m(662), _vm._v(" "), _vm._m(663), _vm._v(" "), _vm._m(664), _vm._v(" "), _vm._m(665), _vm._v(" "), _vm._m(666), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(667), _vm._v(" "), _vm._m(668), _vm._v(" "), _vm._m(669), _vm._v(" "), _vm._m(670), _vm._v(" "), _vm._m(671), _vm._v(" "), _vm._m(672), _vm._v(" "), _vm._m(673), _vm._v(" "), _vm._m(674), _vm._v(" "), _vm._m(675), _vm._v(" "), _vm._m(676), _vm._v(" "), _vm._m(677), _vm._v(" "), _vm._m(678), _vm._v(" "), _vm._m(679), _vm._v(" "), _vm._m(680), _vm._v(" "), _vm._m(681), _vm._v(" "), _vm._m(682), _vm._v(" "), _vm._m(683), _vm._v(" "), _vm._m(684), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(685), _vm._v(" "), _vm._m(686), _vm._v(" "), _vm._m(687), _vm._v(" "), _vm._m(688), _vm._v(" "), _vm._m(689), _vm._v(" "), _vm._m(690), _vm._v(" "), _vm._m(691), _vm._v(" "), _vm._m(692), _vm._v(" "), _vm._m(693), _vm._v(" "), _vm._m(694), _vm._v(" "), _vm._m(695), _vm._v(" "), _vm._m(696), _vm._v(" "), _vm._m(697), _vm._v(" "), _vm._m(698), _vm._v(" "), _vm._m(699), _vm._v(" "), _vm._m(700), _vm._v(" "), _vm._m(701), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(702), _vm._v(" "), _vm._m(703), _vm._v(" "), _vm._m(704), _vm._v(" "), _vm._m(705), _vm._v(" "), _vm._m(706), _vm._v(" "), _vm._m(707), _vm._v(" "), _vm._m(708), _vm._v(" "), _vm._m(709), _vm._v(" "), _vm._m(710), _vm._v(" "), _vm._m(711), _vm._v(" "), _vm._m(712), _vm._v(" "), _vm._m(713), _vm._v(" "), _vm._m(714), _vm._v(" "), _vm._m(715), _vm._v(" "), _vm._m(716), _vm._v(" "), _vm._m(717), _vm._v(" "), _vm._m(718), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(719), _vm._v(" "), _vm._m(720), _vm._v(" "), _vm._m(721), _vm._v(" "), _vm._m(722), _vm._v(" "), _vm._m(723), _vm._v(" "), _vm._m(724), _vm._v(" "), _vm._m(725), _vm._v(" "), _vm._m(726), _vm._v(" "), _vm._m(727), _vm._v(" "), _vm._m(728), _vm._v(" "), _vm._m(729), _vm._v(" "), _vm._m(730), _vm._v(" "), _vm._m(731), _vm._v(" "), _vm._m(732), _vm._v(" "), _vm._m(733), _vm._v(" "), _vm._m(734), _vm._v(" "), _vm._m(735), _vm._v(" "), _vm._m(736), _vm._v(" "), _vm._m(737), _vm._v(" "), _vm._m(738), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(739), _vm._v(" "), _vm._m(740), _vm._v(" "), _vm._m(741), _vm._v(" "), _vm._m(742), _vm._v(" "), _vm._m(743), _vm._v(" "), _vm._m(744), _vm._v(" "), _vm._m(745), _vm._v(" "), _vm._m(746), _vm._v(" "), _vm._m(747), _vm._v(" "), _vm._m(748), _vm._v(" "), _vm._m(749), _vm._v(" "), _vm._m(750), _vm._v(" "), _vm._m(751), _vm._v(" "), _vm._m(752), _vm._v(" "), _vm._m(753), _vm._v(" "), _vm._m(754), _vm._v(" "), _vm._m(755), _vm._v(" "), _vm._m(756), _vm._v(" "), _vm._m(757), _vm._v(" "), _vm._m(758), _vm._v(" "), _vm._m(759), _vm._v(" "), _vm._m(760), _vm._v(" "), _vm._m(761), _vm._v(" "), _vm._m(762), _vm._v(" "), _vm._m(763), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(764), _vm._v(" "), _vm._m(765), _vm._v(" "), _vm._m(766), _vm._v(" "), _vm._m(767), _vm._v(" "), _vm._m(768), _vm._v(" "), _vm._m(769), _vm._v(" "), _vm._m(770), _vm._v(" "), _vm._m(771), _vm._v(" "), _vm._m(772), _vm._v(" "), _vm._m(773), _vm._v(" "), _vm._m(774), _vm._v(" "), _vm._m(775), _vm._v(" "), _vm._m(776), _vm._v(" "), _vm._m(777), _vm._v(" "), _vm._m(778), _vm._v(" "), _vm._m(779), _vm._v(" "), _vm._m(780), _vm._v(" "), _vm._m(781), _vm._v(" "), _vm._m(782), _vm._v(" "), _vm._m(783), _vm._v(" "), _vm._m(784), _vm._v(" "), _vm._m(785), _vm._v(" "), _vm._m(786), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(787), _vm._v(" "), _vm._m(788), _vm._v(" "), _vm._m(789), _vm._v(" "), _vm._m(790), _vm._v(" "), _vm._m(791), _vm._v(" "), _vm._m(792), _vm._v(" "), _vm._m(793), _vm._v(" "), _vm._m(794), _vm._v(" "), _vm._m(795), _vm._v(" "), _vm._m(796), _vm._v(" "), _vm._m(797), _vm._v(" "), _vm._m(798), _vm._v(" "), _vm._m(799), _vm._v(" "), _vm._m(800), _vm._v(" "), _vm._m(801), _vm._v(" "), _vm._m(802), _vm._v(" "), _vm._m(803), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(804), _vm._v(" "), _vm._m(805), _vm._v(" "), _vm._m(806), _vm._v(" "), _vm._m(807), _vm._v(" "), _vm._m(808), _vm._v(" "), _vm._m(809), _vm._v(" "), _vm._m(810), _vm._v(" "), _vm._m(811), _vm._v(" "), _vm._m(812), _vm._v(" "), _vm._m(813), _vm._v(" "), _vm._m(814), _vm._v(" "), _vm._m(815), _vm._v(" "), _vm._m(816), _vm._v(" "), _vm._m(817), _vm._v(" "), _vm._m(818), _vm._v(" "), _vm._m(819), _vm._v(" "), _vm._m(820), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(821), _vm._v(" "), _vm._m(822), _vm._v(" "), _vm._m(823), _vm._v(" "), _vm._m(824), _vm._v(" "), _vm._m(825), _vm._v(" "), _vm._m(826), _vm._v(" "), _vm._m(827), _vm._v(" "), _vm._m(828), _vm._v(" "), _vm._m(829), _vm._v(" "), _vm._m(830), _vm._v(" "), _vm._m(831), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(832), _vm._v(" "), _vm._m(833), _vm._v(" "), _vm._m(834), _vm._v(" "), _vm._m(835), _vm._v(" "), _vm._m(836), _vm._v(" "), _vm._m(837), _vm._v(" "), _vm._m(838), _vm._v(" "), _vm._m(839), _vm._v(" "), _vm._m(840), _vm._v(" "), _vm._m(841), _vm._v(" "), _vm._m(842), _vm._v(" "), _vm._m(843), _vm._v(" "), _vm._m(844), _vm._v(" "), _vm._m(845), _vm._v(" "), _vm._m(846), _vm._v(" "), _vm._m(847), _vm._v(" "), _vm._m(848), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(849), _vm._v(" "), _vm._m(850), _vm._v(" "), _vm._m(851), _vm._v(" "), _vm._m(852), _vm._v(" "), _vm._m(853), _vm._v(" "), _vm._m(854), _vm._v(" "), _vm._m(855), _vm._v(" "), _vm._m(856), _vm._v(" "), _vm._m(857), _vm._v(" "), _vm._m(858), _vm._v(" "), _vm._m(859), _vm._v(" "), _vm._m(860), _vm._v(" "), _vm._m(861), _vm._v(" "), _vm._m(862), _vm._v(" "), _vm._m(863), _vm._v(" "), _vm._m(864), _vm._v(" "), _vm._m(865), _vm._v(" "), _vm._m(866), _vm._v(" "), _vm._m(867), _vm._v(" "), _vm._m(868), _vm._v(" "), _vm._m(869), _vm._v(" "), _vm._m(870), _vm._v(" "), _vm._m(871), _vm._v(" "), _vm._m(872), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(873), _vm._v(" "), _vm._m(874), _vm._v(" "), _vm._m(875), _vm._v(" "), _vm._m(876), _vm._v(" "), _vm._m(877), _vm._v(" "), _vm._m(878), _vm._v(" "), _vm._m(879), _vm._v(" "), _vm._m(880), _vm._v(" "), _vm._m(881), _vm._v(" "), _vm._m(882), _vm._v(" "), _vm._m(883), _vm._v(" "), _vm._m(884), _vm._v(" "), _vm._m(885), _vm._v(" "), _vm._m(886), _vm._v(" "), _vm._m(887), _vm._v(" "), _vm._m(888), _vm._v(" "), _vm._m(889), _vm._v(" "), _vm._m(890), _vm._v(" "), _vm._m(891), _vm._v(" "), _vm._m(892), _vm._v(" "), _vm._m(893), _vm._v(" "), _vm._m(894), _vm._v(" "), _vm._m(895), _vm._v(" "), _c('p', {
    staticClass: "tbx2"
  }, [_vm._v("Combine the cranberries, pears, and apples with the syrup, cinnamon, nutmeg, and vanilla. Stir together until evenly coated. Pour into a lightly oiled 9 × 13–inch baking pan.")]), _vm._v(" "), _vm._m(896), _vm._v(" "), _vm._m(897), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(898), _vm._v(" "), _vm._m(899), _vm._v(" "), _vm._m(900), _vm._v(" "), _vm._m(901), _vm._v(" "), _vm._m(902), _vm._v(" "), _vm._m(903), _vm._v(" "), _vm._m(904), _vm._v(" "), _vm._m(905), _vm._v(" "), _vm._m(906), _vm._v(" "), _vm._m(907), _vm._v(" "), _vm._m(908), _vm._v(" "), _vm._m(909), _vm._v(" "), _vm._m(910), _vm._v(" "), _vm._m(911), _vm._v(" "), _vm._m(912), _vm._v(" "), _vm._m(913), _vm._v(" "), _vm._m(914), _vm._v(" "), _vm._m(915), _vm._v(" "), _vm._m(916), _vm._v(" "), _vm._m(917), _vm._v(" "), _vm._m(918), _vm._v(" "), _vm._m(919), _vm._v(" "), _vm._m(920), _vm._v(" "), _vm._m(921), _vm._v(" "), _vm._m(922), _vm._v(" "), _vm._m(923), _vm._v(" "), _vm._m(924), _vm._v(" "), _vm._m(925), _vm._v(" "), _vm._m(926), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(927), _vm._v(" "), _vm._m(928), _vm._v(" "), _vm._m(929), _vm._v(" "), _vm._m(930), _vm._v(" "), _vm._m(931), _vm._v(" "), _vm._m(932), _vm._v(" "), _vm._m(933), _vm._v(" "), _vm._m(934), _vm._v(" "), _vm._m(935), _vm._v(" "), _vm._m(936), _vm._v(" "), _vm._m(937), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(938), _vm._v(" "), _vm._m(939), _vm._v(" "), _vm._m(940), _vm._v(" "), _vm._m(941), _vm._v(" "), _vm._m(942), _vm._v(" "), _vm._m(943), _vm._v(" "), _vm._m(944), _vm._v(" "), _vm._m(945), _vm._v(" "), _vm._m(946), _vm._v(" "), _vm._m(947), _vm._v(" "), _vm._m(948), _vm._v(" "), _vm._m(949), _vm._v(" "), _vm._m(950), _vm._v(" "), _vm._m(951), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _vm._m(952)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "cn"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/toc#vk2",
      "id": "rk2"
    }
  }, [_vm._v("CHAPTER ONE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ct"
  }, [_c('b', [_c('a', {
    attrs: {
      "href": "#/Text/toc#vk2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("THANKSGIVING")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc1"
  }, [_c('i', [_vm._v("A compassionate way to celebrate"), _c('br'), _vm._v("the holiday everyone loves")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "ic",
    staticStyle: {
      "color": "#FFDC90"
    }
  }, [_vm._v("I")]), _vm._v(" start this book with Thanksgiving, because for many vegans and vegetarians, it’s the Mother of All Holidays. It used to mean being relegated to eating side dishes (and being put on the spot about how rude it is to refuse Aunt Clarabelle’s famous turkey and stuffing), but over the last couple of decades it has grown into a feast for full culinary expression. Though the holiday has a kind of all-American identity, let’s not forget that Canadians celebrate Thanksgiving as well—it’s in October, befitting a harvest festival. And that’s exactly what Thanksgiving’s original intent was—a feast of gratitude for the harvest’s abundance.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h3"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("MIX AND MATCH MENUS FOR THE THANKSGIVING TABLE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you’d like to add any appetizers to the menu, consider the possibilities listed in the "), _c('span', {
    attrs: {
      "href": "#/Text/chap02#page74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Appetizer Buffet")]), _vm._v(" in "), _c('span', {
    attrs: {
      "href": "#/Text/chap02#rk3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter two")]), _vm._v(", "), _c('i', [_vm._v("Christmas")]), _vm._v(", or the listing of "), _c('span', {
    attrs: {
      "href": "#/Text/chap06#page277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Appetizers")]), _vm._v(" in "), _c('span', {
    attrs: {
      "href": "#/Text/chap06#rk7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter six")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h11"
  }, [_c('b', [_vm._v("SOUPS & BREADS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec1"
    }
  }, [_vm._v("Spiced Vegetable Peanut Soup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec2"
    }
  }, [_vm._v("Coconut Butternut Squash Soup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec3"
    }
  }, [_vm._v("Creamy Wild Mushroom Soup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec4"
    }
  }, [_vm._v("Squash, Sweet Potato, and Corn Chowder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#page10"
    }
  }, [_vm._v("Sweet Potato Biscuits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#page11"
    }
  }, [_vm._v("Green Chili Corn Bread or Muffins")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Spiced Vegetable Peanut Soup")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This rich soup is loosely based on an old recipe from the American South that was in turn inspired by an African recipe. Use enough cayenne or hot red pepper flakes to give the soup a pleasant heat. Pass around additional red pepper flakes for those who’d enjoy a spicier soup.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 large celery stalks, finely diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 medium carrots, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons cornmeal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium yellow summer squash, diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium red bell pepper, diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon good-quality curry powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons grated fresh or jarred ginger, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons lemon juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup natural smooth peanut butter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ to 2 cups rice milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Dried hot red pepper flakes, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 good handfuls baby spinach leaves")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ to ½ cup chopped fresh parsley, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Heat the oil in a soup pot. Add the onion, celery, and carrots. Sauté over medium-low heat, stirring frequently, until the vegetables are golden. Sprinkle in the cornmeal and continue to sauté, stirring constantly, until the entire mixture begins to turn a golden brown.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Add 4 cups water along with the squash, bell pepper, curry powder, ginger, and lemon juice. Bring to a gentle boil. Cover and simmer gently over low heat until the vegetables are tender, about 10 to 15 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Whisk in the peanut butter until it is well blended with the liquid. Stir in enough rice milk to give the soup a slightly thick consistency. Add red pepper flakes to give the soup some subtle heat. Season with salt and pepper. Simmer very gently for 10 minutes or so longer, stirring occasionally.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" If time allows, let the soup stand off the heat for an hour or more to allow the flavors to blend, then heat through as needed. Stir in the baby spinach leaves and half the parsley, and use the rest to garnish each serving.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link2"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Coconut Butternut Squash Soup")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2"
  }, [_c('b', [_vm._v("NUT-FREE (if coconut is safe for you)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Once you’ve got the squash baked, this soup comes together quickly. The mellow flavors of squash, kale, and red onions synergize delectably and look gorgeous together as well.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large butternut squash (about 1½ pounds)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large yellow or sweet white onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium apple, any variety, peeled and diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups prepared vegetable broth, or 2 cups water with 1 vegetable bouillon cube")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons good-quality curry powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons grated fresh or jarred ginger, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Pinch of ground nutmeg or allspice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 14-ounce can light coconut milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('b', [_vm._v("GARNISH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 medium red onions, quartered and thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 good-size bunch kale (about 10 to 12 ounces)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" To bake the squash, see "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("the instructions in the sidebar")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Heat about half the oil in a soup pot. Add the onion and sauté over medium-low heat until golden, about 8 to 10 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Add the apple, squash, broth, and spices. Bring to a steady simmer, then cover and simmer gently until the apples are tender, about 10 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Transfer the solids to a food processor with a slotted spoon, in batches if need be, process until smoothly pureed, then transfer back to the soup pot. Or better yet, simply insert an immersion blender into the pot and process until smoothly pureed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Stir in the coconut milk and return the soup to a gentle simmer. Cook over low heat for 5 to 10 minutes, until well heated through. Season with salt and pepper. If time allows, let the soup stand off the heat for an hour or two, then heat through as needed before serving.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" Just before serving, heat the remaining oil in a large skillet. Add the red onions and sauté over low heat until golden and soft.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("7.")])]), _vm._v(" Meanwhile, strip the kale leaves off the stems and cut into thin shreds. Stir together with the onions in the skillet, adding just enough water to moisten the surface. Cover and cook over medium heat, stirring occasionally, until the kale is bright green and just tender, about 5 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("8.")])]), _vm._v(" To serve, ladle soup into each bowl, then place a small mound of kale and onion mixture in the center.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-18.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link3"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Creamy Wild Mushroom Soup")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("Can be made SOY-FREE by omitting the optional tofu"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This flavorful soup gets its creamy thickness from a base of pureed white beans.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 to 3 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 medium potatoes, peeled and diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 large celery stalks, with leaves, diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 32-ounce carton vegetable broth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried basil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup dry white wine, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("12 ounces baby bella or crimini mushrooms, stemmed, wiped clean, and sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 to 6 ounces fresh shiitake mushrooms, stemmed, wiped clean, and sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 15- to 16-ounce can white beans (cannellini), drained and rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 12.3-ounce package firm silken tofu, crumbled (optional, see "), _c('a', {
    attrs: {
      "href": "#/Text/#var1"
    }
  }, [_vm._v("Variation")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups rice milk, or as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup minced fresh parsley for garnish")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Heat the oil in a large soup pot. Add the onions and sauté over medium heat until translucent. Add the garlic and continue to sauté until the onion is golden. Add potatoes, celery, broth, basil, thyme, and optional wine. Bring to a gentle boil, then cover, lower the heat, and simmer gently for 15 to 20 minutes, or until the vegetables are tender.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Meanwhile, combine both varieties of mushrooms in a small skillet or saucepan with enough water to keep the mixture moist. Cover and cook over medium heat for 10 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Add the beans and optional tofu to the soup. Puree the soup in batches in a food processor or blender, then return to the soup pot. Or, simply insert an immersion blender into the pot and process until smoothly pureed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Stir in the cooked mushrooms and add enough rice milk to give the soup a slightly thick consistency. Season with salt and pepper. If time allows, let the soup stand for several hours or overnight.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Heat though before serving and adjust the consistency with more rice milk if too thick; adjust the seasonings as well. Ladle into soup bowls and sprinkle each serving with the parsley.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1",
    attrs: {
      "id": "var1"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATION: ")])]), _vm._v("To make the soup soy-free, use two cans of white beans and omit the tofu.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Squash, Sweet Potato, and Corn Chowder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by using gluten-free bouillon cubes"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Squash, corn, and sweet potato combine to make a hearty chowder that’s perfect for this time of year. Do try to use fresh corn if it’s still available where you live.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium butternut squash (about 1½ pounds)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, finely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 celery stalk, finely diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large sweet potato, peeled and diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 32-ounce carton vegetable broth, or 4 cups water with 2 vegetable bouillon cubes (gluten- and soy-free, if need be)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 bay leaves")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons cumin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried basil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2½ to 3 cups corn kernels, cooked fresh from about 3 medium ears or thawed frozen corn kernels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup rice milk, or as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup minced fresh parsley, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" With a sharp knife, cut the squash across the center of the rounded part. Remove the seeds and fibers. Slice the squash into ½-inch rings, then peel each ring and cut into small dice. If you don’t have a knife (or the patience) for this task, partially bake the squash as "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("directed in the sidebar")]), _vm._v(" to make the cutting and peeling easier.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Heat the oil in a soup pot. Add the onion and celery and sauté over medium heat until the onion is golden. Add the squash and sweet potato dice and enough broth or water to cover all but about an inch of the vegetables. Bring to a simmer, then add the bay leaves and other seasonings. Simmer gently, covered, until the squash and potatoes are tender, about 25 to 30 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" With a slotted spoon, scoop out 2 heaping cups of the solid ingredients, mash them well, and stir back into the soup. Or simply insert an immersion blender into the soup pot and puree a small portion of the ingredients—enough to give the base of the soup some thickness.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Add the corn and enough rice milk to give the soup a slightly thick consistency. Season with salt and pepper, then simmer over low heat for 10 to 15 minutes longer.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Serve at once, or let the soup stand for an hour or so before serving, then heat through as needed. Stir in the parsley just before serving. This may also be cooked a day ahead and refrigerated, since its flavor develops nicely overnight.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "page10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link5"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Sweet Potato Biscuits")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES 12 TO 16")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Delightfully moist and slightly sweet, these biscuits are delicious served with seasonal soups.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txb2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium sweet potato")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2"), _c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cups spelt flour or whole wheat pastry flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup Earth Balance or other non-hydrogenated margarine")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup maple syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup coarsely chopped walnuts or pecans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Cook, bake, or microwave the sweet potato until tender. When cool enough to handle, peel and cut it into large chunks, then mash well.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Combine the flour, baking powder, and salt in a food processor fitted with either the metal blade or the dough blade. Pulse on and off a few times.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Add the margarine and pulse on and off until it is evenly distributed in the flour.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Add the sweet potato and drizzle in the maple syrup. Process until the mixture holds together as a soft dough. Add the nuts and pulse on and off until they are evenly distributed in the dough.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" Line a baking sheet with parchment paper. Pinch off sections of the dough (it will be slightly sticky, so flour your hands if you’d like) to form 2-inch balls (make slightly smaller if you’d like to have more to go around). Flatten lightly and arrange in rows on the baking sheet.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("7.")])]), _vm._v(" Place on the center rack in the oven and bake for 12 to 15 minutes, or until a knife inserted into the center of a biscuit tests clean and the bottoms are lightly brown. Transfer the biscuits to a plate and serve warm.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "page11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link6"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Green Chili"), _c('br'), _vm._v("Corn Bread or Muffins")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2"
  }, [_c('b', [_vm._v("Can be made SOY-FREE by using coconut yogurt and soy-free nondairy cheese"), _c('br'), _vm._v("NUT-FREE (for those who aren’t also allergic to coconut)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES 1 DOZEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Served warm out of the oven, green chili corn bread or muffins are great companions to harvest soups. Nondairy cheese definitely adds a major “yum” factor, so do try it if you can.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup cornmeal, preferably stone ground")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup whole wheat pastry flour or unbleached white flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 6-ounce container plain soy yogurt or coconut yogurt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup rice milk, or as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 small fresh hot chili, seeded and minced, or one 4-ounce can chopped mild green chilies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup frozen corn kernels, thawed, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup grated nondairy cheese, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 400° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the first 5 (dry) ingredients in a mixing bowl and stir together.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Pour the batter into an oiled 9 × 9–inch baking pan, or divide among 12 foil-lined muffin tins. Bake for 20 to 25 minutes, or until the tops are golden and a knife inserted in the center of a muffin tests clean. Let cool slightly, then transfer the muffins to a serving plate, leaving them in the foil liners.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTE: ")])]), _vm._v("A piece of this corn bread is depicted in the photo of "), _c('a', {
    attrs: {
      "href": "#/Text/intro#ima123"
    }
  }, [_vm._v("Butternut Squash Soup")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h11",
    attrs: {
      "id": "page12"
    }
  }, [_c('b', [_vm._v("SALADS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec7"
    }
  }, [_vm._v("Tri-Color Coleslaw")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec8"
    }
  }, [_vm._v("Sweet Potato–Poppy Seed Coleslaw")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec9"
    }
  }, [_vm._v("Mixed Baby Greens with Pears and Glazed Pecans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec10"
    }
  }, [_vm._v("Massaged Kale Salad with Cranberries and Cashews")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc2",
    attrs: {
      "id": "link11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec11"
    }
  }, [_vm._v("Jícama Salad with Fennel and Oranges")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link7"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Tri-Color Coleslaw")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("NUT-FREE (if seeds are safe for you, otherwise omit)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This easy slaw is an old standby for my holiday meals. Kale gives it a deeper flavor and additional color, not to mention a nice nutritional boost.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups thinly shredded red cabbage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups thinly shredded white or Napa cabbage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cup thinly shredded kale")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup dried cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup toasted pumpkin or sunflower seeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup vegan mayonnaise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 to 2 tablespoons lemon juice, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Combine all the ingredients in a serving bowl and mix thoroughly. Serve at once or cover and refrigerate until needed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-24.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link8"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Sweet Potato–Poppy Seed Coleslaw")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("4 TO 6 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("A rich raw cashew dressing, lots of poppy seeds, and above all, the surprise of raw sweet potato combine to make a festive variation on classic coleslaw.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup raw cashews")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium sweet potato, peeled")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups green cabbage, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup red cabbage, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 scallions, green part only, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons minced fresh dill, or ½ teaspoon dried")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons black sesame seeds, chia seeds, or poppy seeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Juice of ½ lemon, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Place the cashews in a small bowl and pour ½ cup of boiling water over them. Let stand for 10 to 15 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Peel the sweet potato and cut into coarse chunks. In a food processor fitted with the grating blade, grate the sweet potato, then transfer to a serving bowl. Add the two cabbages, scallions, dill, and seeds. Stir together.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Rinse the food processor, then fit with the regular blade. Place the cashews and any unabsorbed water in the work bowl. Process until the mixture is fairly smooth. Add the lemon juice and salt and process until creamy.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Pour the cashew mixture over the slaw and stir together. Season with pepper. Let the slaw stand for a few minutes before serving, or up to an hour, to allow the flavors to blend.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link9"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Mixed Baby Greens with Pears"), _c('br'), _vm._v(" and Glazed Pecans")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Here’s a burst of color for the holiday plate that’s nutritious and invigorating as well.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("GLAZED PECANS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup agave nectar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Pinch of cinnamon Pinch of salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup pecan halves")]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("GREENS AND PEARS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 to 6 ounces mixed baby greens")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 good handfuls of baby spinach or arugula")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ medium head radicchio, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup baby carrots, halved lengthwise if slender, quartered if thick")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 medium Bosc pears, cut into quarters lengthwise, cored, seeded, and diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons lemon juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Heat the agave nectar in a small skillet and sprinkle in the cinnamon and salt. When it just starts to get bubbly, stir in the pecans. Cook over low heat, stirring frequently, until the pecans are nicely glazed, 3 to 5 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the remaining ingredients in a serving bowl and toss together. Just before serving, add the pecans and toss again.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-27.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link10"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Massaged Kale Salad with"), _c('br'), _vm._v("Cranberries and Cashews")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("Can be made SOY-FREE by using a soy-free vegan salad dressing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This is a salad that my family enjoys pretty much all year round, save when tomatoes beckon in the summer. But I’ll always associate it with Thanksgiving, because that is when I first encountered raw “massaged” kale in a salad at the home of our great friends Wendy and Harry. There are so many ways to vary this salad: You can toss in some slivered baby carrots, substitute another kind of nut, or add a bit of thinly shredded red cabbage for extra color or sliced celery or bok choy for extra crunch. Even in its simple form, as presented here, it’s luscious and festive. I find it almost addictive; but I suppose that if one is going to be addicted to something, it may as well be kale!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 good-size bunch kale, washed and dried")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Olive oil or other healthy vegetable oil, as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup dried cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup crushed toasted cashews, or pumpkin seeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup vegan mayonnaise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 to 2 tablespoons lemon juice, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Strip the kale leaves off the stems. Cut into ribbons and place in a large bowl. With a little olive oil rubbed into your palms, massage the kale for a minute or so, until it becomes bright green and softens a bit.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Stir in the remaining ingredients and serve at room temperature.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("OPTIONAL ADDITIONS AND VARIATIONS:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link11"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Jícama Salad with"), _c('br'), _vm._v("Fennel and Oranges")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE (if seeds are safe for you)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("In the fall, jícamas are fairly easy to come by. My local supermarket, which isn’t located in a sophisticated urban center, carries them at this time of year. I highly recommend getting acquainted with this offbeat veggie. Deceptively plain on the outside, it yields a burst of crisp, slightly sweet texture and flavor. If unavailable, substitute 2 to 3 medium turnips, and you’ve still got a lovely autumn salad.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium jícama, peeled and cut into narrow 1½-inch-long strips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 clementines or other small seedless oranges, sectioned")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 fennel bulb, very thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 scallions, green parts only, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ to ½ cup chopped fresh cilantro, parsley, or dill, or a combination")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 ounces mixed baby greens")]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("DRESSING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Juice of ½ to 1 lime, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon agave nectar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup toasted pumpkin seeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Combine the first 6 ingredients in a serving bowl.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the dressing ingredients in a small bowl and whisk until blended. Pour the dressing over the salad and toss together. Scatter the pumpkin seeds over the top and serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h11"
  }, [_c('b', [_vm._v("MAIN DISHES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec12"
    }
  }, [_vm._v("Butternut Squash with Whole Wheat, Wild Rice, and Onion Stuffing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec13"
    }
  }, [_vm._v("Quinoa and Lentil-Stuffed Golden Squashes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec14"
    }
  }, [_vm._v("Rice and Pecan-Stuffed Squash")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec15"
    }
  }, [_vm._v("“Three Sisters” Stew")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec16"
    }
  }, [_vm._v("Pueblo Corn Pie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec17"
    }
  }, [_vm._v("Baked Thanksgiving Risotto")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec18"
    }
  }, [_vm._v("Black Bean and Sweet Potato Tortilla Casserole")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec19"
    }
  }, [_vm._v("Ravioli with Sweet Potatoes and Sage")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec20"
    }
  }, [_vm._v("Hearty Vegetable Pot Pie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link12"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Butternut Squash with Whole Wheat,"), _c('br'), _vm._v("Wild Rice, and Onion Stuffing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by using gluten-free bread"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Here’s one of my favorite holiday main dishes, which I adapted slightly from the original recipe in")]), _vm._v(" Vegetarian Celebrations. "), _c('i', [_vm._v("Instead of using dried sage, as in the earlier version, this recipe uses fresh sage leaves (which are so much nicer) plus a few other tweaks for deeper flavor. This satisfying dish makes a handsome centerpiece for a festive meal.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 medium-small butternut squashes (about 1 pound each)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¾ cup raw wild rice, rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups prepared vegetable broth, or 2 cups water with 1 vegetable bouillon cube")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large red onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 to 3 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2½ cups firmly packed torn whole wheat bread")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("5 or 6 fresh sage leaves, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 to 3 teaspoons all-purpose seasoning blend (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page31"
    }
  }, [_vm._v("sidebar")]), _vm._v("), or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup fresh orange juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Bake the squashes until tender but still firm enough to hold their shape, according to the "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("directions in the sidebar")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Meanwhile, combine the wild rice with the broth in a saucepan. Bring to a gentle boil, then cover and simmer gently until the water is absorbed, about 40 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Heat the oil in a skillet. Add the onion and sauté until translucent. Add the garlic and continue to sauté until the onion is golden.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v("In a mixing bowl, combine the cooked wild rice with the sautéed onion and the remaining ingredients. When the squashes are cool enough to handle, scoop out the pulp, leaving firm shells about ½ inch thick. Chop the pulp and stir it into the rice mixture. Stuff the squashes, place in foil-lined baking dishes, and cover.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Before serving, place the squashes in a preheated 350° F oven. Bake for 20 to 30 minutes, depending on the size of the squashes, or until fork-tender and well heated through."), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATION: ")])]), _vm._v("To add drama to this presentation, try this recipe with other squash varieties. Hubbard squash, delicata, sweet dumpling, and golden nugget are just a few of the stuffable squashes available.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("HOW TO BAKE WINTER SQUASHES"), _c('br'), _vm._v("OR SUGAR PUMPKINS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Cut away large stems from squash or pumpkin, then cut it in half (you’ll need a really good knife to do this!). Place the halves, cut side up, in a foil-lined, shallow baking dish and cover tightly with more foil.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Bake for 30 to 50 minutes, depending on the size of the squash and what you intend to do with it. If you ultimately need firm slices or chunks, or if you’ll be stuffing and re-baking the vegetable, bake only until you can just pierce the flesh with a fork or knife. If you’ll be pureeing the flesh, as for a pie or a soup, bake until easily pierced with a knife.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" If you don’t have a knife sharp enough to cut through a raw winter squash or sugar pumpkin, don’t worry; prebaking partially makes squashes and pumpkins much easier to cut. Place the whole vegetable in the foil-lined baking dish. Cover loosely with foil and bake 15 minutes for smaller squashes, or 25 to 30 minutes for larger squashes and sugar pumpkins.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" When cool enough to handle, remove the stem and cut the squash in half lengthwise.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6.")]), _vm._v(" Scoop out the pulp and seeds. Then proceed with directions given in individual recipes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link13"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Quinoa and Lentil-Stuffed"), _c('br'), _vm._v("Golden Squashes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Here’s a hearty rendition of stuffed squash. For a lovely visual effect, use red quinoa or a combination of red and regular quinoa.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 small winter squashes (carnival, golden acorn, delicata, or other small winter squash)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup raw quinoa, rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups prepared vegetable broth, or water with 1 vegetable bouillon cube")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large red onion, finely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium red bell pepper, finely diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup orange juice, preferably fresh squeezed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons ground cumin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon ground turmeric")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 to 2 teaspoons grated fresh or jarred ginger, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 15- to 16-ounce can lentils, drained and rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup minced fresh parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Bake the squashes until tender but still firm enough to hold their shape, according to the "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("directions in the sidebar")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" When the squashes are cool enough to handle, scoop out and discard the seeds. Scoop out the squash pulp, leaving a sturdy shell of about ½ inch all around. Chop the pulp finely.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Heat the oil in a large skillet. Add the onion and sauté over medium heat until translucent. Add the garlic and bell pepper and sauté over medium heat until the onion is golden. Add the cooked quinoa, orange juice, and seasonings. Stir together and cook for 2 to 3 minutes longer, then gently stir in the lentils and half the parsley. Season with salt and pepper.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Stuff each squash half generously with the quinoa mixture. Sprinkle each with the remaining parsley. Bake for 20 to 25 minutes, then serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link14"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Rice and Pecan-Stuffed Squash")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by making crumbs from gluten-free bread"), _c('br'), _vm._v("SOY-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Squash and pecans make for a memorable duo when combined in this Creole-inspired recipe. The savory nut, bread, and rice stuffing, contrasted with the smooth sweetness of the butternut squash, makes for a perfect holiday main or side dish.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 medium golden acorn or delicata squashes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, finely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¾ to 1 cup soft whole-grain breadcrumbs (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page30"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups cooked brown rice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup finely chopped pecans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup fresh orange juice, or as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons maple syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons fresh thyme leaves")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried oregano")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Pinch of nutmeg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Sprigs of fresh thyme for garnish")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Bake the squashes according to the "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("directions in the sidebar")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" When the squash is done and cool enough to handle, discard the seeds, then scoop out the pulp, leaving a sturdy, ½-inch shell all around. Chop the pulp, and add it to the pecan mixture.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Add the orange juice, more or less as needed to moisten the mixture, followed by the syrup and herbs. Season with salt, pepper, and nutmeg, mix thoroughly, and stuff the squash shells. Bake for 20 to 25 minutes, then serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" For butternut squashes, serve each squash half as a hearty main dish; or cut each half across to serve 8 as a smaller portion. For golden acorn or delicata, serve each half as a main dish portion.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link15"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("“Three Sisters” Stew")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Squash, corn, and beans are known as the “Three Sisters\" in Native American mythology. In some legends, the sisters are also the daughters of the Earth Mother. These three crops were central to the first Thanksgiving feasts. This hearty dish is very much like a robust chili, with the addition of squash. It’s delicious served with "), _c('a', {
    attrs: {
      "href": "#/Text/#page10"
    }
  }, [_vm._v("Sweet Potato Biscuits")]), _vm._v(" or "), _c('a', {
    attrs: {
      "href": "#/Text/#page11"
    }
  }, [_vm._v("Green Chili Corn Bread or Muffins")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 small sugar pumpkin or 1 large butternut squash (about 2 pounds), peeled and cut into large dice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 to 4 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ medium green or red bell pepper, cut into short, narrow strips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 14- to 16-ounce can diced tomatoes, with liquid")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 15- to 16-ounce can pinto or red beans, drained and rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups fresh corn kernels (from 2 large or 3 medium ears; substitute thawed frozen corn if fresh is unavailable)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 or 2 small fresh hot chilies, seeded and minced, or one 4-ounce can chopped mild green chilies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons cumin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons chili powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon dried oregano")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup minced fresh cilantro, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Bake the pumpkin or squash according to the "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("directions in the sidebar")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Heat the oil in a soup pot. Add the onion and sauté over medium-low heat until translucent. Add the garlic and continue to sauté until the onion is golden.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Add the pumpkin or squash dice, 1½ cups water, and all the remaining ingredients except the last 2 and bring to a simmer. Simmer gently, covered, until all the vegetables are tender, about 20 to 25 minutes. Season with salt and pepper.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" If time allows, let the stew stand for 1 to 2 hours before serving, then heat through. Just before serving, stir in the cilantro. The stew should be thick and moist but not soupy; add additional broth if needed. Serve in shallow bowls.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link16"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Pueblo Corn Pie")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("Can be made SOY-FREE by using a soy-free nondairy cheese"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This layered casserole, adapted from a Native American recipe, is another one of my old standbys for Thanksgiving. I love how the simple chili contrasts with the cheesy cooked cornmeal topping.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium green or red bell pepper, diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups cooked fresh or thawed frozen corn kernels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2¼ cups canned or cooked pinto beans 2 cups chopped ripe tomatoes, or one 14- to 16-ounce can diced tomatoes, lightly drained")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons chili powder, or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon dried oregano")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon ground cumin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1¼ cups cornmeal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup grated cheddar-style nondairy cheese, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Heat the oil in a large skillet. Add the onion and sauté until translucent. Add the garlic and bell pepper and continue to sauté until the onion is golden brown.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Add the corn kernels, pinto beans, tomatoes, and seasonings. Stir well and simmer for 10 to 15 minutes. Season to taste with salt. Remove from the heat.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Bring 5 cups of water to a rolling boil in a heavy saucepan or double boiler. Slowly pour the cornmeal into the water in a thin, steady stream, whisking continuously to avoid lumping. Add the salt and cook over very low heat, covered, for 20 minutes, stirring occasionally.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Oil a shallow 1½-quart baking dish and line the bottom with half the cooked cornmeal. Pour the skillet mixture in and gently pat it in evenly. Sprinkle with the optional grated cheese. Top with the remaining cornmeal, patting it in smoothly.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" Bake for 45 to 50 minutes, or until the cornmeal is golden brown and crusty. Let stand for 10 minutes, then cut into squares to serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link17"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Baked Thanksgiving Risotto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Creamy, comforting risotto is given a festive seasonal spin with the “Three Sisters” of the native harvest—corn, squash, and beans.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups Arborio rice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 32-ounce carton vegetable broth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 cloves garlic, very finely minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 15- to 16-ounce can small red or pinto beans, drained and rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium red onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups peeled winter squash (butternut, delicata, or golden acorn), cut into ½-inch dice (see "), _c('a', {
    attrs: {
      "href": "#/Text/#note9"
    }
  }, [_vm._v("Note")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup fresh or thawed frozen corn kernels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 ounces baby spinach")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup minced fresh parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Cherry tomatoes or sun-dried tomato strips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the rice with the broth, one additional cup of water, and the garlic in a deep 2-quart casserole dish. Cover and bake for 1 hour, stirring every 15 minutes. At the third stirring, stir in one more cup of water and the beans. When done, the rice should have a tender and creamy texture.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" About halfway through the baking process, heat the olive oil in a large skillet. Add the onion and sauté until golden. Add the squash and a little water (enough to keep the skillet moist) and cover. Cook until the squash is tender but still firm. Add the corn kernels and cook until both they and the squash are done.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Add the spinach, then cover and cook just until it’s wilted. Once the risotto is out of the oven, carefully transfer to a larger serving dish (a large, shallow casserole dish or a large, shallow pasta plate both work well). Stir in the vegetable mixture from the skillet, then season with salt and pepper.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Sprinkle the parsley over the top of the risotto followed by a scattering of fresh or dried tomatoes. Serve at once or cover and keep warm until serving.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1",
    attrs: {
      "id": "note9"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTE: ")])]), _vm._v("To make the squash easier to cut, partially prebake according to the "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("directions in the sidebar")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link18"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Black Bean and Sweet Potato"), _c('br'), _vm._v("Tortilla Casserole")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("Can be made SOY-FREE by using a soy-free vegan cheese"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("12 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("There’s something delectable about the harmony of black beans and sweet potatoes. Add spinach and tomatillo salsa to the mix and you’ve got gorgeous layers of color and lively contrasts of flavor.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 large sweet potatoes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 15- to 16-ounce can black beans, drained and rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 16-ounce jar salsa verde (tomatillo salsa)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 scallions, white and green parts, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup minced cilantro or parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("10 to 12 ounces baby spinach, rinsed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("10 to 12 corn tortillas")]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("CHEESY SAUCE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups rice milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 tablespoons cornstarch or arrowroot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups grated cheddar-style nondairy cheese")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Cook, bake, or microwave the sweet potatoes until done but still firm. When cool enough to handle, peel and cut into ½-inch-thick slices.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Preheat the oven to 400° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" In a mixing bowl, combine the beans, 1 cup of the salsa, scallions, and cilantro and stir together.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Place the spinach in a large skillet or small soup pot and cook over medium-high heat just until barely wilted down. Transfer to a colander and use the bottom of a bowl, fitted into the colander, to press excess liquid from the spinach.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Combine about ½ cup of the rice milk with the cornstarch in a small bowl. Whisk together until smoothly blended—no lumps!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" In a small saucepan, heat the remaining rice milk. Sprinkle in 1½ cups of the cheese and set the remainder aside. Bring the sauce to a gentle simmer, then whisk in the dissolved thickener. Continue to cook, whisking almost constantly, until the cheese is melted and the sauce is smooth and thick. Add salt sparingly (you may not need much, depending on the saltiness of the cheese).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("7.")])]), _vm._v(" Oil a rectangular shallow 2-quart casserole dish. Layer as follows: half the tortillas, the black bean mixture, the sliced sweet potatoes, the spinach, the remaining salsa, half the cheese sauce, the remaining tortillas, the remaining cheese sauce. Finally, sprinkle the reserved cheese over the top.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("8.")])]), _vm._v(" Bake for 20 minutes, or until the cheese sauce is bubbly. Let the casserole stand for 10 minutes, then cut into squares to serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link19"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Ravioli with Sweet Potatoes and Sage")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Hearty pasta, sweet potatoes, creamy sauce, crunchy crumbs, and aromatic sage come together in a dish that I can only describe as swoon-worthy.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 medium sweet potatoes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon extra-virgin olive oil")]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("CREAMY SAUCE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons Earth Balance or other non-hydrogenated margarine")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 12.3-ounce container silken tofu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup rice milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon salt, or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Pinch of nutmeg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("16 ounces vegan ravioli (see "), _c('a', {
    attrs: {
      "href": "#/Text/#note10"
    }
  }, [_vm._v("Note")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("6 to 8 ounces baby spinach")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ to ¾ cup fresh breadcrumbs (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page30"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Small fresh sage leaves, as desired, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Bake or microwave the sweet potatoes ahead of time until done but still nice and firm. When cool enough to handle, peel and cut into ½- to ¾-inch dice. Transfer to a mixing bowl, toss with the oil, and sprinkle lightly with salt.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Preheat the oven to 400° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Heat the margarine in a small skillet. Add the garlic and sauté over low heat until golden. Transfer to a food processor along with the tofu, rice milk, salt, nutmeg, and pepper. Process until the mixture is completely smooth.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Cook the ravioli in plenty of rapidly simmering water in a large cooking pot, according to package directions, until "), _c('i', [_vm._v("al dente")]), _vm._v(". Just before draining the ravioli, plunge the spinach into the cooking water so that it wilts. Drain the ravioli and spinach mixture at once, then transfer it back to the cooking pot. Add the creamy sauce, and stir gently to coat the ravioli and spinach.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Transfer the ravioli mixture to an attractive, shallow, lightly oiled baking dish. Top with the diced sweet potatoes, then sprinkle evenly with the breadcrumbs. Scatter sage leaves over them.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" Bake for 15 to 18 minutes, or until the sauce is bubbly and the crumbs are golden and crisp. Serve at once.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1",
    attrs: {
      "id": "note10"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTE: ")])]), _vm._v("Many brands of vegan ravioli are filled with tofu, which is fine and dandy, but even better, in my humble opinion, are veggie-filled ravioli. One good brand is Rising Moon Organics, which makes three vegan variations: Spinach Florentine, Garlic and Roasted Veggies, and Butternut Squash. Soy Boy also makes some wonderful vegan raviolis. You can find these in the freezer cases of natural foods stores.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h3",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("A NOTE ON ALL-PURPOSE"), _c('br'), _vm._v("SEASONING BLENDS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link20"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Hearty Vegetable Pot Pie")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("SOY-FREE (if seasoning blend is soy-free)"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES TWO PIES, 12 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Watch your guests’ faces light up when you serve this nostalgic classic. Using prepared whole-grain pie crusts makes pot pies a snap to prepare.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("8 medium potatoes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, quartered and finely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 cups diced vegetables of your choice (choose 3 or 4 from among cauliflower, broccoli, leeks, peas, corn kernels, zucchini, yellow summer squash, mushrooms, kale, etc.)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons unbleached white flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup vegetable broth (homemade or store-bought)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup nutritional yeast (optional but highly recommended)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons all-purpose seasoning blend (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page31"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup minced fresh parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 9-inch prepared good-quality piecrusts, preferably whole grain")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup fine whole-grain breadcrumbs (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page30"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Paprika for topping")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Cook or microwave the potatoes in their skins until done. When cool enough to handle, peel them. Dice 4 potatoes and mash the other 4 coarsely. Set aside until needed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Heat the oil in a large skillet. Add the onion and sauté over medium heat until golden. Add the vegetables of your choice, layering quicker-cooking vegetables like peas, corn, and zucchini over longer-cooking ones like cauliflower, broccoli, and leeks (although none of these are terribly long-cooking). Add a bit of water; cover and cook until the vegetables are tender but not overdone, about 5 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Sprinkle the flour into the skillet, then pour in the broth. Cook for a minute or two, stirring constantly until the liquid thickens. Stir in both the diced and mashed potatoes. Heat through gently. Stir in the nutritional yeast, seasoning blend, thyme, and parsley. Season with salt and pepper. Pour the mixture into the pie crust and pat in.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Sprinkle the breadcrumbs evenly over each pie, then top with a sprinkling of paprika. Bake for 35 to 40 minutes, or until the crust is golden. Let the pies stand at room temperature for 10 minutes or so, then cut into wedges and serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h11"
  }, [_c('b', [_vm._v("STUFFINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec21"
    }
  }, [_vm._v("Wild Rice Stuffing with Dried Cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec22"
    }
  }, [_vm._v("Whole Wheat Stuffing with Pine Nuts and Dried Fruit")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec23"
    }
  }, [_vm._v("Walnut-Apple Stuffing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec24"
    }
  }, [_vm._v("Sauerkraut, Potato, and Apple Stuffing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec25"
    }
  }, [_vm._v("Polenta, Sausage, and Mushroom Stuffing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link21"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Wild Rice Stuffing with"), _c('br'), _vm._v("Dried Cranberries")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by making breadcrumbs from gluten-free bread"), _c('br'), _vm._v("SOY-FREE (if seasoning blend is soy-free)"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Wild rice adds a wonderful texture to this stuffing, and the dried cranberries make it simply delicious.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2½ cups water or prepared vegetable broth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup raw wild rice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium red onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 large celery stalks, diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 cups whole-grain breadcrumbs (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page30"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup dried cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon ground cumin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon good-quality curry powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup apple juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Bring the water or broth to a simmer in a small saucepan. Stir in the wild rice, bring to a simmer, then cover and simmer gently until the water is absorbed, about 35 minutes. Once done, preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Heat the oil in a medium skillet. Add the onion and celery and sauté over medium heat until both are golden.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Combine the onion-celery mixture with the cooked wild rice and all the remaining ingredients except the apple juice in a mixing bowl. Stir well to combine. Slowly drizzle in the apple juice, stirring constantly, until the mixture is evenly moistened.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Transfer the mixture to a lightly oiled, large shallow baking dish and bake for 25 to 30 minutes, or until the top begins to get slightly crusty. Keep warm until serving.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link22"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Whole Wheat Stuffing with"), _c('br'), _vm._v("Pine Nuts and Dried Fruit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by using gluten-free specialty bread"), _c('br'), _vm._v("SOY-FREE (if seasoning blend is soy-free)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This versatile stuffing is good on its own or stuffed into winter squashes or green or red bell peppers.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("6 cups firmly packed diced whole-grain bread, or the soft inner bread from a large whole-grain Italian loaf")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large red onion, finely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 scallions, white and green parts, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup chopped fresh parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Leaves from 2 sprigs fresh rosemary, or 8 fresh sage leaves that have been thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon all-purpose seasoning blend (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page31"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup toasted pine nuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup dark or golden raisins, or "), _c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup sliced dried apricots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup vegetable broth (homemade, see "), _c('span', {
    attrs: {
      "href": "#/Text/chap03#page112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Vegetable Soup with Vegan Matzo Balls")]), _vm._v(", or prepared), or as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Place the diced bread on a baking sheet. Bake 10 to 12 minutes, or until dry and lightly browned.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Heat the oil in a large skillet. Add the onion and sauté over medium heat until golden.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Combine the bread cubes with the onion in a mixing bowl. Add all the remaining ingredients except the broth and toss together. Slowly drizzle in the broth, stirring, to moisten the ingredients evenly.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5")]), _vm._v(".")]), _vm._v(" Transfer the mixture to a shallow, oiled 1½-quart baking pan, or stuff into bell peppers or winter squashes (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("sidebar")]), _vm._v("). Bake for 30 to 35 minutes, or until browned and still slightly moist. Stir once during the baking time.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link23"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Walnut-Apple Stuffing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by using gluten-free bread"), _c('br'), _vm._v("SOY-FREE (if seasoning blend is soy-free)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 TO 10 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This stuffing, lightly sweetened with apple, is one of my longtime favorites.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("6 cups firmly packed diced wholegrain bread")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large sweet white onion, such as Vidalia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 peeled, diced tart apples, such as Granny Smith")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup chopped fresh parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon dried tarragon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon all-purpose seasoning blend (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page31"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup finely chopped walnuts or pecans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup apple juice, or as needed")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 350² F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Place the diced bread on a baking sheet. Bake 10 to 12 minutes, or until dry and lightly browned.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Heat the oil in a large skillet. Add the onion and sauté over medium heat until golden. Add the apple and sauté for 5 minutes longer.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" In a mixing bowl, combine the bread cubes with the onion and apple mixture. Add all the remaining ingredients except the apple juice and toss together. Drizzle in the apple juice slowly, stirring at the same time to moisten the ingredients evenly.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Transfer the mixture to an oiled shallow 1½-quart baking pan. Bake 30 to 35 minutes, or until the mixture is lightly browned and still slightly moist. Stir once during the baking time.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-47.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link24"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Sauerkraut, Potato,"), _c('br'), _vm._v("and Apple Stuffing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by using gluten-free bread"), _c('br'), _vm._v("SOY-FREE (if seasoning blend is soy-free)"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This recipe is inspired by a Slavic stuffing. Sweet apple contrasted with tart sauerkraut gives it a unique flavor twist.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 medium red-skinned or golden potatoes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons olive or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large red onion, chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 large sweet apples, peeled, cored, and thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 8-ounce can or jar sauerkraut, lightly drained")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups fresh breadcrumbs (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page30"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons all-purpose seasoning blend (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page31"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons paprika")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon poppy seeds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Cook, bake, or microwave the potatoes until done but still firm. When cool enough to handle, peel and dice them.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Heat the oil in a skillet. Add the onion and sauté over medium-low heat until golden. In a mixing bowl, combine the onion with all the remaining ingredients and mix thoroughly. Pat into a lightly oiled 1½-quart casserole dish.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Bake for 40 to 45 minutes, or until the top is golden brown. Cover and keep warm until serving. This stuffing may be made ahead of time and then reheated before serving.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link25"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Polenta, Sausage, and"), _c('br'), _vm._v("Mushroom Stuffing")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made GLUTEN-FREE by using the variation"), _c('br'), _vm._v("Can be made NUT-FREE by omitting the optional pine nuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Using prepared polenta makes for a nice change-of-pace stuffing. By using vegan sausages, it just misses being a gluten-free stuffing, but I do provide an all-polenta variation, which would indeed make it gluten-free.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 18-ounce tube polenta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 14-ounce package Tofurky or Field Roast vegan sausages, sliced ½-inch thick")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("6 ounces cremini or baby bella mushrooms, sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 tablespoons olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large onion, preferably red, quartered and thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup diced celery")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 sprigs rosemary leaves")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup minced fresh parsley")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons all-purpose seasoning blend (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page31"
    }
  }, [_vm._v("sidebar")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("6 to 8 fresh sage leaves, thinly sliced, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ to ½ cup vegetable broth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup toasted pine nuts for topping, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 400° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Cut the polenta into ½-inch-thick slices, then cut each slice into 8 little wedges. Combine with the sliced sausages and mushrooms in a large mixing bowl. Drizzle in half the oil and toss to coat. Spread evenly in a lightly oiled or parchment-lined roasting pan. Bake for 20 minutes, stirring after 10 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Meanwhile, heat the remaining oil in a medium skillet. Add the onion and sauté over medium heat until translucent. Add the celery and continue to sauté until both it and the onion are golden.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Once the polenta and sausage mixture has roasted for 20 minutes, stir in the onion and celery mixture; then stir in the rosemary leaves, parsley, thyme, seasoning blend, optional sage leaves, and salt and pepper. Drizzle in a bit of broth, just enough to moisten the mixture but not drench it. Bake for 10 minutes longer.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Remove from the oven, and transfer to a serving bowl or casserole dish. If using pine nuts, sprinkle over the top. Cover and keep the stuffing warm or serve at once.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATION: ")])]), _vm._v("For a gluten-free version of this stuffing use an additional 18-ounce tube of polenta in place of the sausages.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h11"
  }, [_c('b', [_vm._v("SIDE DISHES AND SAUCES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec26"
    }
  }, [_vm._v("Maple-Pecan Sweet Potatoes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec27"
    }
  }, [_vm._v("Rosemary-Citrus Sweet Potatoes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec28"
    }
  }, [_vm._v("Agave and Mustard-Glazed Brussels Sprouts or Green Beans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec29"
    }
  }, [_vm._v("Red Wine–Roasted Brussels Sprouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec30"
    }
  }, [_vm._v("Smashed Potatoes with Mushroom Gravy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec31"
    }
  }, [_vm._v("Red Quinoa Pilaf with Kale and Corn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec32"
    }
  }, [_vm._v("Cranberry-Apple Sauce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec33"
    }
  }, [_vm._v("Cranberry Chutney")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link26"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Maple-Pecan"), _c('br'), _vm._v("Sweet Potatoes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 TO 10 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("How lovely that one of the healthiest veggies around is so traditional at the Thanksgiving table. Here are two simple recipes that showcase sweet potatoes.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 large or 6 medium sweet potatoes (about 4 pounds), peeled and sliced ¼ inch thick")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup maple syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup Earth Balance or other non-hydrogenated margarine, melted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup orange juice, preferably fresh")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup pecans, coarsely chopped")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Leaves from 2 to 3 sprigs fresh rosemary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Arrange the sweet potato slices in overlapping rows in an oiled shallow 2-quart casserole. In a small bowl, combine the syrup, margarine, juice, cinnamon, and salt. Pour evenly over the potatoes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Cover with lid or foil and bake, covered, for 25 to 30 minutes, or until readily pierced with a fork but still firm.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Scatter the pecans and rosemary leaves over the surface of the sweet potatoes. Bake for 20 to 25 minutes longer, uncovered, or until glazed and golden around the edges.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link27"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Rosemary-Citrus"), _c('br'), _vm._v("Sweet Potatoes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("Can be made SOY-FREE by replacing margarine with olive oil or other healthy vegetable oil"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This is a variation on the classic recipe more often referred to as “candied yams.” Did you know that calling sweet potatoes “yams” is actually a misnomer? Yams are rarely sold in this country, so quite often, what you’re actually buying are sweet potatoes. I make this dish nearly every Thanksgiving dinner.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons Earth Balance or other non-hydrogenated margarine, melted")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Juice of 2 oranges (½ to ¾ cup)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup agave nectar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 to 2 teaspoons pumpkin pie spice, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("5 large sweet potatoes, peeled and sliced ¼ inch thick")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Fresh rosemary leaves from 2 sprigs, or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 375° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the first 4 ingredients in a large mixing bowl and stir to blend. Add the sliced potatoes, toss gently, and transfer to a lightly oiled shallow 1½-quart round or 9 × 13–inch oblong baking dish.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Cover and bake until the sweet potatoes are just tender, about 40 minutes. Stir once or twice during that time to distribute the liquid over the potatoes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Stir in the rosemary leaves, then bake, uncovered, until the glaze thickens, about 10 to 15 minutes. Cover and keep warm until ready to serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-53.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link28"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Agave and Mustard-Glazed"), _c('br'), _vm._v("Brussels Sprouts or Green Beans")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("Can be made NUT-FREE by omitting optional nuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This easy, sweet, and mustardy glaze is a fantastic way to add a burst of flavor to Brussels sprouts or green beans.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup agave nectar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup yellow mustard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ pounds Brussels sprouts or green beans (see "), _c('a', {
    attrs: {
      "href": "#/Text/#note12"
    }
  }, [_vm._v("Note")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Pinch of salt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Toasted pine nuts, slivered almonds, or pumpkin seeds for garnish, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Combine the agave nectar, mustard, and olive oil in a small bowl and stir together.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" If using Brussels sprouts, stem them and cut them in half. If using green beans, trim the tips.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Place the vegetables in a skillet with just enough water to keep moist. Steam until bright green and just tender-crisp, not a moment longer!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Pour in the agave-mustard mixture and a pinch of salt. Turn up the heat to medium-high and cook, stirring, until the vegetables are nicely glazed, about 2 to 3 minutes. Make sure they stay bright green! Remove from the heat, sprinkle with the optional nuts, and serve at once, straight from the skillet.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1",
    attrs: {
      "id": "note12"
    }
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTE: ")])]), _vm._v("Though clearly out of season in most areas, green beans are one of the traditional vegetables favored at the Thanksgiving table. Personally, I prefer to serve the other iconic green veggie of the holiday—Brussels sprouts. They are more seasonal for this time of year. If you do wish to serve green bean dishes, by all means do so if you can find good, fresh ones. If those elude you, I see nothing wrong with using whole organic frozen green beans. They’ll save you a lot of work and they are consistently delicious.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link29"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Red Wine–Roasted"), _c('br'), _vm._v("Brussels Sprouts")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("The slightly sweet glaze gives Brussels sprouts and their companion veggies a rich flavor.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ to 2 pounds Brussels sprouts, stemmed and halved lengthwise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 medium red bell pepper, cut into narrow strips, about 2 inches long")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup baby carrots, halved lengthwise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 to 3 cloves garlic, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup dry red wine")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 tablespoons agave nectar or maple syrup, or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ tablespoons reduced-sodium soy sauce, or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried tarragon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 425° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine all the ingredients in a large mixing bowl. Transfer to a foil-lined roasting pan. Roast for 30 minutes, stirring every few minutes, or until the vegetables are touched with brown spots here and there and nicely glazed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Transfer to a serving bowl and keep warm until needed, or serve at once.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-55.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link30"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Smashed Potatoes with Mushroom Gravy")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE (if using optional nutritional yeast, make sure it’s gluten-free)"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES AS MANY SERVINGS AS NEEDED (1 potato per serving)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Simple as the dish is, making mashed potatoes for a crowd is a considerable amount of work. Here, you get the same great flavors with a fraction of the work. Potatoes are baked, smashed, and topped with a delicious gravy.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 large baking potato per person, well scrubbed")]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("GRAVY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 tablespoon olive oil or other healthy vegetable oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup minced shallots or red onion")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups thinly sliced fresh mushrooms (about 2 to 3 ounces); try a combination of shiitake and baby bella or cremini")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups prepared vegetable broth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons reduced-sodium soy sauce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 tablespoons cornstarch or arrowroot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ teaspoon dried thyme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons nutritional yeast, optional (but highly recommended)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 375° F or 400° F, depending on what else you have in the oven. Either temperature works well for baking potatoes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Line a baking dish with foil. Arrange the potatoes in it and cover snugly with more foil. Bake for 40 to 45 minutes, or until the potatoes are easily pierced with a knife. Potatoes can be made ahead.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Shortly before serving, prepare the gravy. Heat the oil in a large saucepan. Add the shallots and sauté over medium-low heat until golden and just beginning to brown.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Add the mushrooms, cover, and cook until the mushrooms have wilted down, about 8 minutes. Add the broth and soy sauce.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Combine the cornstarch or arrowroot with just enough water to dissolve in a cup or small container. When the liquid in the saucepan comes to a steady simmer, slowly whisk in the dissolved cornstarch, stirring constantly until the liquid is thickened.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" Remove from the heat and whisk in the thyme and yeast. Transfer to a small pitcher or gravy boat for easy pouring.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("7.")])]), _vm._v(" Just before serving, reheat the potatoes if needed (either by returning to a hot oven for about 15 minutes, or in the microwave). Cut each potato in half and arrange on a serving platter, cut side up.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("8.")])]), _vm._v(" Using a potato masher, smash each potato half, flattening lightly and creating lots of indentations for the delicious gravy to pool into. Pour a little gravy over each potato half, then pass around additional gravy for individual use.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-57.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link31"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Red Quinoa Pilaf"), _c('br'), _vm._v("with Kale and Corn")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE (use a soy-free bouillon cube)"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This nutrition-packed side dish is so hearty that, with the addition of some beans, it could be a simple entree. Black beans are a perfect fit for this.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups red quinoa, rinsed in a fine sieve")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 cups prepared vegetable broth or 3 cups water with 1 vegetable bouillon cube")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 bunch kale (about 8 ounces)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons extra-virgin olive oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 to 6 cloves garlic, minced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 scallions, white and green parts, thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 cups cooked fresh or thawed frozen corn kernels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 jarred roasted red peppers, cut into strips, or "), _c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup oil-packed sun-dried tomatoes, cut into strips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons lemon juice, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon sweet paprika")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon ground cumin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon dried rosemary")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Salt and freshly ground pepper to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Combine the quinoa with 3 cups broth in a medium saucepan. Bring to a rapid simmer, then cover and continue to simmer gently until the broth is absorbed, about 15 to 20 minutes. If the quinoa isn’t quite done, add an additional ½ cup broth (or water) and continue to cook until absorbed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Strip the kale leaves away from the stems. Discard the stems, or slice them very thinly. Cut the kale leaves into narrow strips. Rinse well and set aside.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Meanwhile, heat the oil in a large skillet or stir-fry pan. Add the garlic and sauté over low heat until golden.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Add the kale, stir together, and cover; raise the heat to medium and cook until wilted, about 2 to 3 minutes. Add the remaining ingredients and cook, stirring frequently for 4 to 5 minutes longer. Transfer to a serving bowl or casserole dish and serve at once, or cover until needed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link32"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Cranberry-Apple Sauce")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 OR MORE SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Apples provide a sweet contrast to the tart cranberries in this lively rendition of the traditional holiday relish.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 12-ounce bag fresh cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 sweet apples, any variety, peeled and diced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup natural granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup apple juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ teaspoon ground ginger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Pinch of allspice or nutmeg")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup golden or dark raisins")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Combine all the ingredients except the raisins in a large saucepan. Stir together, bring to a simmer, then cover and continue to simmer gently until the cranberries have burst and the apples are tender, about 20 to 25 minutes.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Stir in the raisins and allow to cool, uncovered. Transfer to a serving bowl and serve at room temperature.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-59.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link33"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Cranberry Chutney")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("SOY-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This spiced chutney is a perfect venue for cranberries.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("12 ounces fresh cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup peeled, finely diced apple or 1 cup finely diced fresh or canned pineapple")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup apple, orange, or pineapple juice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup chopped dried apricots")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons grated fresh or jarred ginger, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon ground cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon ground cloves")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Dried hot red pepper flakes to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 to 4 tablespoons agave nectar or maple syrup, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Place all the ingredients except the agave nectar in a saucepan and bring to a simmer. Cover and simmer gently for 20 to 25 minutes, or until the most of the liquid is absorbed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Add agave nectar to taste and simmer uncovered for 5 to 10 minutes longer, until thickened. Let the chutney cool to room temperature. Transfer to a serving bowl. If making ahead, transfer to a tightly sealed jar or container. Refrigerate until needed. Before serving, bring to room temperature.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h11"
  }, [_c('b', [_vm._v("DESSERTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec34"
    }
  }, [_vm._v("Classic Vegan Pumpkin Pie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec35"
    }
  }, [_vm._v("Pumpkin Cheesecake with a Hint of Chocolate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec36"
    }
  }, [_vm._v("Pear, Apple, and Cranberry Crumble")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec37"
    }
  }, [_vm._v("Cranberry-Carrot Cake with Maple–Cream Cheese Frosting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "serv"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/flow.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "link38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#rec38"
    }
  }, [_vm._v("Cashew Chocolate Mousse Pie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link34"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Classic Vegan Pumpkin Pie")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES TWO 9-INCH PIES, 6 TO 8 SERVINGS EACH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1"
  }, [_c('i', [_vm._v("Thanksgiving dinner without pumpkin pie is almost unimaginable to most people, no matter what their dietary bent. To that end, I present two versions of this iconic dessert. Still, though it’s hard for us pumpkin pie fans to imagine, there are plenty of people who don’t care for it. (“Je n’aime pas le citrouille,” said the Parisian mother of my niece-by-marriage at a recent Thanksgiving gathering. My brother-in-law concurred, “I’m not a big pumpkin pie fan.”) Since I have two pumpkin pie naysayers in my family, I’m sure there are others out there. For them, I’ve provided a trio of additional desserts to choose from.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('i', [_vm._v("This is just as good made with butternut squash as it is with sugar pumpkin. Once the pumpkin or squash is baked, which you can (and should) do ahead of time, the pie comes together quickly. It goes down very easily, which is why I recommend making two pies for practically the same effort as one.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("4 cups well-baked sugar pumpkin or butternut squash")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 12.3-ounce package firm silken tofu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1"), _c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cups natural granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 teaspoons pumpkin pie spice mix")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 9-inch good-quality natural pie crusts (pastry or graham cracker)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the prebaked pumpkin or squash pulp in a food processor with the next 4 ingredients and process until velvety smooth. If you have a small or medium-size processor, you may need to do this with half the ingredients at a time.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Pour the filling into the crust. Bake for 40 to 45 minutes, or until the mixture is set and the crust is golden. Let the pies cool to room temperature. Cut into 6 or 8 wedges to serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx1"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("VARIATION: ")])]), _vm._v("If you need a major shortcut, use a 15- to 16-ounce can of pureed pumpkin. It’s not as good as fresh, but a shortcut pumpkin pie is better than no pumpkin pie at all! Use organic canned pumpkin, which tends to be more flavorful than other commercial varieties.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link35"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Pumpkin Cheesecake with"), _c('br'), _vm._v("a Hint of Chocolate")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made NUT-FREE by slightly increasing chocolate chips and omitting walnuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES ONE 9-INCH PIE, 6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Here’s a cheesecake-like version of pumpkin pie that offers a subtle chocolate twist with each bite (see "), _c('a', {
    attrs: {
      "href": "#/Text/intro#pagexii"
    }
  }, [_vm._v("photo")]), _vm._v(").")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ chocolate chips")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup walnuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 9-inch good-quality natural pastry crust, preferably whole grain")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 12.3-ounce container extra-firm silken tofu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup vegan cream cheese")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅔")]), _vm._v(" cup natural granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1½ cups well-baked, coarsely mashed sugar pumpkin or butternut squash (see "), _c('a', {
    attrs: {
      "href": "#/Text/#page22"
    }
  }, [_vm._v("sidebar")]), _vm._v(" for baking tips)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon pumpkin pie spice, or more, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup chocolate chips for optional chocolate drizzle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Vegan whipped cream for garnish, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Combine the chocolate chips and walnuts in a food processor and pulse on and off until finely chopped.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Scatter the chocolate chip–walnut mixture evenly over the bottom of the piecrust and set aside.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Combine half the tofu, half the cream cheese, and half the sugar in a food processor and process until smoothly pureed. Pour into the piecrust and smooth down with a cake spatula.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Combine the pumpkin or squash pulp in the food processor with the remaining tofu, cream cheese, and sugar, along with the cinnamon and pumpkin pie spice. Process until smoothly pureed, then pour into the pie crust over the plain tofu layer. Smooth down with a cake spatula.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" Bake for 40 to 45 minutes, or until the mixture is set and the crust is golden. Let the pie cool to room temperature. Cut into 6 or 8 wedges to serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("7.")])]), _vm._v(" If you’d like to garnish each slice of pie with chocolate drizzle, melt the chocolate chips in a heatproof bowl in the microwave (start with 45 seconds) or in the top of a double boiler. Transfer the melted chips to a pastry piping bag or, less fancy but almost as effective, a Ziploc bag. If using the latter, snip a tiny hole in one corner. Gently squeeze the melted chocolate over each wedge of pie in an attractive zigzag pattern.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link36"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Pear, Apple, and"), _c('br'), _vm._v("Cranberry Crumble")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made SOY-FREE by using a soy-free frozen dessert (such as one based on coconut)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("Though pies are a more traditional finale for the Thanksgiving meal, crumbles are more about the fruit than the pastry. That’s especially true for this one, with a trio of the season’s favorite fruits.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup fresh cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("3 medium Bosc pears, cored and thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 large crisp apples, peeled, cored, and thinly sliced")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup maple syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ teaspoon ground nutmeg or allspice")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon vanilla extract")]), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx1"
  }, [_c('b', [_vm._v("TOPPING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup whole wheat pastry flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup wheat germ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup sliced almonds")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¼ cup natural granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons safflower oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Frozen dessert for topping, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Place the cranberries in a food processor. Pulse on and off until coarsely chopped.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Combine the first 5 topping ingredients in a small bowl and stir together. Drizzle in the oil and stir until the dry ingredients are evenly moistened. Sprinkle the topping evenly over the fruit mixture.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Bake for 40 minutes, or until the fruits are soft and the topping is golden. Serve warm, topping each serving with a dollop of frozen dessert such as coconut ice cream, if desired.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link37"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Cranberry-Carrot Cake with"), _c('br'), _vm._v("Maple–Cream Cheese Frosting")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("Can be made SOY-FREE by omitting the frosting"), _c('br'), _vm._v("Can be made NUT-FREE by omitting the walnuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("This cake is festive and luscious, but with a minimum of fat and a plethora of fresh fruit (and a vegetable!) in the batter—not the least bit guilt-inducing. Using a springform pan makes it easier to release this cake in a lovely, intact round, but the same can be achieved with a flexible silicone pan.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("8 to 10 ounces fresh cranberries")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup natural granulated sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1¾ cups whole wheat pastry or spelt flour")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons ground flaxseeds, optional")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon baking powder")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon baking soda")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon ground ginger")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ teaspoon cinnamon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup applesauce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup maple syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons safflower or other light oil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 teaspoon vanilla extract")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup grated carrot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang1"
  }, [_c('b', [_vm._v("Maple–Cream Cheese frosting ("), _c('a', {
    attrs: {
      "href": "#/Text/#adc1"
    }
  }, [_vm._v("see following recipe")]), _vm._v(")")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup finely chopped walnuts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Place the cranberries in a food processor and pulse on and off until evenly and finely chopped. Transfer to a bowl. Add the sugar, stir well, and set aside.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" In a large mixing bowl, combine the flour, optional flaxseeds, baking powder, baking soda, ginger, and cinnamon. Stir to combine thoroughly.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Make a well in the center and add the applesauce, syrup, safflower oil, and vanilla. Stir until the wet and dry ingredients are completely combined, but don’t overmix.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("5.")])]), _vm._v(" Stir the cranberries and carrots into the batter. Pour into a lightly oiled 9-inch round cake pan or springform pan (see recipe introduction). Bake for 30 to 35 minutes, or until a knife inserted into the center tests clean.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("6.")])]), _vm._v(" If using the walnuts, toast them in a small dry skillet over medium heat until they brown lightly. Once the cake has cooled to room temperature, release from the pan if you’ve used a springform or other easy-to-release pan and spread the frosting over the top evenly, allowing it to drip fetchingly over the sides. Otherwise, leave the cake in the pan and simply frost the top.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("7.")])]), _vm._v(" Sprinkle evenly with the optional walnuts, then cut into wedges to serve.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-66.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "adc1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Maple–Cream Cheese Frosting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txc"
  }, [_c('b', [_vm._v("GLUTEN-FREE"), _c('br'), _vm._v("NUT-FREE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES ABOUT ¾ CUP, enough to frost one average-size cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("I love this simple frosting on fruit- or vegetable-based baked goods, especially those containing carrots or pumpkin.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("½ cup vegan cream cheese")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 to 3 tablespoons maple syrup, to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("2 tablespoons rice milk or other plain or vanilla vegan milk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Combine the ingredients in a food processor. Process until creamy and smooth. Use a flexible cake spatula to remove from the work bowl. Spread on cakes or cupcakes once they’ve cooled to room temperature.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-67.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tx"
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "rec38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/#link38"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F58221"
    }
  }, [_vm._v("Cashew Chocolate Mousse Pie")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_vm._v("MAKES ONE 9-INCH PIE, 6 TO 8 SERVINGS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('i', [_vm._v("If you’ve had your fill of pumpkins, squashes, and other orange vegetables, ending the meal with a chocolaty dessert is a good alternative. Even though this pie is rich, it disappears quickly, no matter how full everyone claims to be. And depending on how many you are serving, you may want to make two.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/line.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 cup raw cashews")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 12.3-ounce package firm silken tofu")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("¾ cup semi-sweet chocolate chips, preferably cane juice sweetened")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_c('span', {
    staticClass: "fbold"
  }, [_vm._v("⅓")]), _vm._v(" cup pure maple syrup, or to taste")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "hang"
  }, [_c('b', [_vm._v("1 prepared 9-inch piecrust (pastry crust or graham cracker)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("1.")])]), _vm._v(" Place the cashews in a small heatproof bowl. Pour 1 cup boiling water over them; cover and let stand for 30 to 60 minutes, then pour off the water.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("2.")])]), _vm._v(" Preheat the oven to 350° F.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("3.")])]), _vm._v(" Place the cashews in a food processor and process until they begin to hold together like butter. Add the tofu and process until completely smooth. Transfer to a small saucepan and add the chocolate chips. Cook over medium-low heat, stirring often, until the chocolate chips have melted. Stir in the maple syrup.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tbx2"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "color": "#3DAE48"
    }
  }, [_vm._v("4.")])]), _vm._v(" Pour the mixture into the crust and bake for 30 minutes, or until the top of the filling feels fairly firm to the touch. Allow the pie to cool completely, then refrigerate for at least an hour, preferably two, before serving.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "ser",
    attrs: {
      "id": "page58"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/p-69.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-230eee50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap01.vue
// module id = 75
// module chunks = 0